import { Component, HostListener, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyWord } from 'src/app/shared/classes/constants';
import { FilterPipe } from 'src/app/shared/pipes/filter.pipe';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';
import { KeywordData } from '../../shared/classes/keywordData';
import { Socket } from 'ngx-socket-io';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx-js-style';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import * as countries from '../../shared/countries.json'
import { Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { CalculateClusterService } from 'src/app/shared/services/calculateCluster.service';
import Gleap from 'gleap';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [FilterPipe],
  encapsulation: ViewEncapsulation.Emulated
})

export class DashboardComponent implements OnInit {
  local_setting : boolean = false
  Lists : any = []
  listName : any = ''
  separateExcelLoader : boolean = false   
  exclude_any_keywords : any = []
  exclude_fix_keywords_backup : any = []
  include_fix_keywords : any = []
  include_any_keywords : any = []
  allSelect! : boolean 
  isOpen : boolean = false 
  excludeKeyword : any = ''
  includeKeyword : any = ''
  clusterExcelLoader : boolean = false
  excelLoader : boolean = false
  selectedData : boolean = false
  allDataSelected : boolean = false
  userName: any = ""
  hideKeywordAry: any[] = []
  keyWordCountry: string = ''
  keyWordLanguage: string = ''
  keyWordName: string = ""
  isAllChecked: boolean = false;
  topicData: any[] = [];
  backupTopicData: any[] = [];

  openPopup: boolean = false;
  title: string = '';
  panelOpenState: boolean = false;
  panelOpenStatetopic: boolean = false;
  isSidebarOpen: boolean = true;

  activateLink: string = 'All';
  includedWords: string[] = []
  excludedWords: string[] = [];
  paginateData: any[] = [];
  includeWord = new FormControl('');
  excludeWord = new FormControl('');
  countedWord: number = 0;
  checked: boolean = false;
  keyWordData: any[] = [];
  backupKeyWordData: KeywordData[] = []

  masterSelected!: boolean;
  page: number = 1;
  count: number = 4;
  tableSize: number = 50;
  searchText: string = ""
  totalData: string = "0";
  keyWordArray = KeyWord.keyWordArray;
  theme: boolean = true;
  matMenuName: any;
  matMenuItemArray: any[] = [];
  lckrKeyWordData: any[] = [];
  selectedMainKeyWordData: any = [];

  matMenuArg: string = '';
  lid: any = "";
  statusMenuArray = KeyWord.statusMenuArray
  intentMenuArray = KeyWord.intentMenuArray;
  weakSpotMenuArray = KeyWord.weakSpotMenuArray;
  formusMenuArray = KeyWord.formusMenuArray;
  analyseMenuArray = KeyWord.analyseMenuArray;
  serpScoreMenuArray = KeyWord.serpScoreMenuArray;
  paaLength: number = 0;
  suggestionLength: number = 0;
  questionLength: number = 0;
  compitionLength: number = 0;
  relatedLength: number = 0;
  loading: boolean = false;
  topicloading: boolean = false;
  keyWordId: any = "";
  queryString: string = "";
  allLength: number = 0;
  weakSpotFilter: string[] = [];
  volFilter = { max: "", min: "" };
  cpcFilter = { max: "", min: "" };
  intentFilter: string[] = [];
  statusFilter: string[] = [];
  forumFilter: string[] = [];
  topicFilter: string[] = [];
  serpScoreFilter: string[] = [];
  suggestion: number = 0;
  question: number = 0;
  all: number = 0;
  clickCount: number = 0;
  getkeywords: string[] = [];
  dataskeyword: any;
  newword: any;

  visible = true;
  volUparrow: boolean = false;
  volDownarrow: boolean = false;

  totalKeywordUpArrow: boolean = false;
  totalKeywordDownArrow: boolean = false;
  weakKeywordUpArrow: boolean = false;
  weakKeywordDownArrow: boolean = false;
  ldaUpArrow: boolean = false;
  ldaDownArrow: boolean = false;
  cpcUpArrow: boolean = false;
  cpcDownArrow: boolean = false;
  serpUpArrow: boolean = false;
  serpDownArrow: boolean = false;
  weakSpotUpArrow: boolean = false;
  weakSpotDownArrow: boolean = false
  backupKeyWordArray: any[] = [];
  waiting8MinutesArray: any[] = [];
  waiting8MinutesBackupArray: any[] = [];
  hideArray: any[] = [];
  backupHideArr: any[] = [];
  hiddenDataBackupArr: any[] = [];
  hiddenDataLength: number = 0;
  selectedKeyWordDatas: any[] = [];
  selectedMainKeyWordDatas: any[] = [];
  uid: any = '';
  jumpToPageCount: number = 1;
  sortedBackupKeywordData: any[] = [];
  // Tabs variables
  allPaginateData: any[] = [];
  suggestionPaginateData: any = [];
  questionsPaginateData: any = [];
  paaPaginateData: any[] = [];
  hiddenPaginateData: any = [];
  relatedSearchedPaginateData: any[] = [];
  competitionPaginateData: any[] = [];
  display = 'none';
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  confirmationPopupData: string = '';
  highintentLength: number = 0;
  postPurchaseLength: number = 0;
  prePurchaseLength: number = 0;
  comparisionLength: number = 0;
  wholeKeywordReportLength: number = 0;
  checkVolFilterAvailable: boolean = false;
  checkCpcFilter: boolean = false;
  checkTopicFlter: boolean = false;
  buttonArg: any[] = [];
  keyWordType: string | null = "";
  activeFilterCount = 0;
  countryValues: any = countries;
  searchTopic: string = "";
  cookies: any = "";
  isLogin: boolean = true;
  exportData: any[] = [];
  exportSelectedData: any[] = [];
  checkStatus: boolean = false;
  overAllanalyse: number = 0;
  completedAnalyse: number = 0;
  clusterData: any[] = [];
  topResults: string = "10";
  SERPSimilarity: string = "3";
  isCollapsed = false;
  clusterLength: number = 0;
  top10Data: any[] = [];
  panels = ['First', 'Second', 'Third'];
  clusteredData: any[] = [];
  clusterBindingData: any = [];
  isClicked: boolean = false;
  eventSubscription: any
  daLessthan10: boolean = false;
  daLessthan20: boolean = false;
  showPopup: boolean = false;
  cutrrentPop:any;
  // settingsData: any = {};
  settingsData: {
    maxDa: number,
    mySites: string[],
    customDomain: string[],
    type: string,
    theme: any
  } = {
      maxDa: 30,
      mySites: [],
      customDomain: [],
      type:"",
      theme:this.theme
    }
  settingObj : any = {}
  showDataFetching: boolean = false;

  get menu() {
    return this.theme ? 'providers-menu' : ''
  }

  get popover() { 
    return !this.theme ? 'dark-popover ' : ''
  }

  get customPopover() { 
    return !this.theme ? 'custom-popover ' : ''
  }

  @HostListener('window:scroll', [])
  onWindowScroll(event: any) {
    if (event.srcElement.scrollTop >= 100) {
      this.showPopup = true;
    } else {
      this.showPopup = false;
    }
  }
  constructor(private themingService: ThemingService,
    private modal: NgbModal,
    private editorService: EditorService,
    private route: ActivatedRoute,
    private socket: Socket,
    public _snackBar: MatSnackBar,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private metaService: Meta,
    private location: Location,
    private cookieServ: CookieService,
    private clustureService: CalculateClusterService,
    private router: Router,
  ) {
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res;
      this.settingsData.theme = res;
    })
    // let _theme = sessionStorage.getItem("theme");
    // if (_theme == "false") {
    //   this.theme = false
    // } else {
    //   this.theme = true
    // }

    this.loading = true;
    this.socket.on('lowfruitAnalysisCompleted', (data: any) => {
      this.backupKeyWordArray = [];
      this.waiting8MinutesBackupArray = [];
      this.waiting8MinutesArray = [];
      this.overAllanalyse = 0;
      this.completedAnalyse = 0;
      if (!!data && !!data.data) {
        this.getAllData();
      }
    });

    this.socket.on('lowfruitAnalysisVolDataCompleted', (data: any) => {
      this.backupKeyWordArray = [];
      this.waiting8MinutesBackupArray = [];
      this.waiting8MinutesArray = [];
      this.overAllanalyse = 0;
      this.completedAnalyse = 0;
      if (!!data) {
        this.getAllData();
      }
    });
    // for (let element of document.getElementsByClassName('track-scrolling')) {
    //   element.addEventListener('scroll', (e:any) => {
    //     return this.onWindowScroll();
    //   });
    // }
  }



  ngOnInit(): void {
    this.themingService.pingThemeName();
    this.panelOpenState = false;
    this.route?.queryParams?.subscribe(params => {
      let keyWordType = params['type']
      if (!!keyWordType) sessionStorage.setItem("keyWordType", keyWordType)
    });

    this.keyWordType = sessionStorage.getItem("keyWordType")
    this.keyWordType == 'list' ? this.isSidebarOpen = false : this.isSidebarOpen = true
    this.uid = this.cookieServ.get("uid");
    this.userName = this.cookieServ.get("userName");
    this.route?.params?.subscribe(params => {
      let keyWordId = params['id'];
      this.themingService.setId( params['id'])
      if (!!keyWordId) sessionStorage.setItem("keyWordId", keyWordId)
      this.keyWordId = sessionStorage.getItem("keyWordId")
      if (!!this.keyWordId) {
        this.getAllData();
      }
    })
  this.location.replaceState(`/lckr/dashboard/${this.keyWordId}`);

    // this.uid = "u-8842b392-d3ae-11ed-bbac-7738ed7ada70";

    if (!this.uid || !localStorage.getItem('auth_token') ) {
      this.isLogin = false
    }else if(this.keyWordType != 'list'){
      // this.getGlobalSettingData()
      this.getListNames()
    }
    let interval = setInterval(() => {
      if (this.voluman_data.length == 0) {
        this.editorService.getKeyWordData({
          "uid": this.uid ? this.uid : "",
          "type": this.keyWordType ? this.keyWordType : "",
          "lid": this.keyWordId,
        }).subscribe(res => {
          try {
            if(res?.error){
              this.toastr.error( res?.error ? res?.error : "please enter valid lid" )
              return
            }
            // this.lckrKeyWordData = res;
            res?.forEach((v: any) => {
              if (!!v.lowfruit_keywords) {
                this.voluman_data = v?.volume_data;
                this.getSuggestionAndQuestion('All');
                this.getSuggestionAndQuestion('Suggestion');
                this.getSuggestionAndQuestion('Question');
                // this.getSuggestionAndQuestion('PAA');
                // this.getSuggestionAndQuestion('Competition');
                // this.getSuggestionAndQuestion('Related Searches');
                this.getSuggestionAndQuestion('Hidden');
                // this.getSuggestionAndQuestion('Cluster');
                this.changePaginateData(this.activateLink);
              }
            })
          } catch (error:any) {
           this.toastr.error(error.message) 
          }
        })
      } else {
        clearInterval(interval);
      }
    }, 10000);

    this.editorService.getFlag().subscribe((res)=>{
      if(res == false){
        this.settingObj.type = "local"
        this.editorService.sendLocalSettingData(this.settingObj)
        this.settingsData.maxDa = this.settingObj.maxDa
        this.settingsData.customDomain = this.settingObj.customDomain
        this.settingsData.mySites = this.settingObj.mySites
        this.settingsData.type = "local"
        this.settingsData.theme = this.theme
      this.getSuggestionAndQuestion('All');
      this.getSuggestionAndQuestion('Suggestion');
      this.getSuggestionAndQuestion('Question');
      this.getSuggestionAndQuestion('PAA');
      this.getSuggestionAndQuestion('Competition');
      this.getSuggestionAndQuestion('Related Searches');
      this.getSuggestionAndQuestion('Hidden');
      this.getSuggestionAndQuestion('Cluster');
      this.changePaginateData(this.activateLink);
      }else if(res == true){
        this.settingObj.type = "global"
        this.settingsData.type = "global"
        this.editorService.saveGlobalSettingTrue({lid:this.keyWordId}).subscribe((res:any)=>{
          if(res){
            this.getGlobalSettingData()
            this.getAllData()
            this.toastr.info("global setting update successfully")
          }
        })
      }
    })

  }

  ngOnDestroy(): void {
    sessionStorage.removeItem("topicsdata");
    this.socket.removeListener("lowfruitAnalysisCompleted");
  }
  toggleCollapse(): void {
    this.visible = !this.visible;
  }
  openPop(popup?:any){
    if(!!popup){
      this.cutrrentPop = popup
      popup.open();
    }else{
      this.cutrrentPop.open();
    }
   
  }
  openPopp(index?:number){
    let doc = document.getElementById(`divv${index}`);
    doc!.style.background="transparent";
    doc!.style.opacity="0";  
  }
  closePop(index:number){
    this.cutrrentPop?.close();
  }



  getAllData(loadArg?: string) {
    this.loading = true
    this.editorService.getKeyWordData({
      "uid": this.uid ? this.uid : "",
      "type": this.keyWordType ? this.keyWordType : "",
      "lid": this.keyWordId,
    }).subscribe(res => {
      try {
        if(res?.error){
        this.loading = false
          this.toastr.error( res?.error ? res?.error : "please enter valid lid" )
          return
        }
        this.lckrKeyWordData = res;
        res?.forEach((v: any) => {
          if (!!v.lowfruit_keywords) {
            // if(this.isLogin){
              this.settingObj.maxDa = v?.max_da === 0 ? 30 : v?.max_da;
              this.settingObj.customDomain = (v?.highlight_domain !== '' && v?.highlight_domain !== undefined ) ? JSON.parse(v?.highlight_domain?.replace(/'/g, '"')) : [];
              this.settingObj.mySites = (v?.my_site !== '' && v?.my_site !== undefined ) ? JSON.parse(v?.my_site?.replace(/'/g, '"')) : [];
              this.local_setting = v?.local_setting != undefined ? v?.local_setting : false
              if(this.local_setting == false && this.isLogin && this.keyWordType != 'list' ){
                this.getGlobalSettingData()
              }else{
                this.settingsData.maxDa = v?.max_da === 0 ? 30 : v?.max_da;
                this.settingsData.customDomain = (v?.highlight_domain !== '' && v?.highlight_domain !== undefined ) ? JSON.parse(v?.highlight_domain?.replace(/'/g, '"')) : [];
                this.settingsData.mySites = (v?.my_site !== '' && v?.my_site !== undefined ) ? JSON.parse(v?.my_site?.replace(/'/g, '"')) : [];
                this.settingsData.theme = this.theme
              }
            // }
            this.voluman_data = v?.volume_data
  
            if(this.keyWordType == "customkeywords"){
              this.exclude_any_keywords = v?.lowfruit_keywords?.json_data?.data?.exclude_fix_keywords !== undefined ? v?.lowfruit_keywords?.json_data?.data?.exclude_fix_keywords?.map((v:any)=>{ 
                return {'title':v,'selected':false}
               }) : [];
               this.exclude_fix_keywords_backup = v?.lowfruit_keywords?.json_data?.data?.exclude_fix_keywords !== undefined ? v?.lowfruit_keywords?.json_data?.data?.exclude_fix_keywords : [];
               this.include_fix_keywords = v?.lowfruit_keywords?.json_data?.data?.include_fix_keywords !== undefined ? v?.lowfruit_keywords?.json_data?.data?.include_fix_keywords?.map((v:any)=>{ 
                 return {'title':v,'selected':false}
                }) : [];
               this.include_any_keywords = v?.lowfruit_keywords?.json_data?.data?.include_any_keywords !== undefined ? v?.lowfruit_keywords?.json_data?.data?.include_any_keywords?.map((v:any)=>{ 
                 return {'title':v,'selected':false}
                }) : [];
  
            }else if(this.keyWordType == "list"){
              this.exclude_any_keywords = v?.lowfruit_keywords?.json_data?.data?.exclude_fix_keywords !== undefined ? v?.lowfruit_keywords?.json_data?.data?.exclude_fix_keywords?.map((v:any)=>{ 
                return {'title':v,'selected':false}
               }) : [];
               this.exclude_fix_keywords_backup = v?.lowfruit_keywords?.json_data?.data?.exclude_fix_keywords !== undefined ? v?.lowfruit_keywords?.json_data?.data?.exclude_fix_keywords : [];
               this.include_fix_keywords = v?.lowfruit_keywords?.json_data?.data?.include_fix_keywords !== undefined ? v?.lowfruit_keywords?.json_data?.data?.include_fix_keywords?.map((v:any)=>{ 
                 return {'title':v,'selected':false}
                }) : [];
               this.include_any_keywords = v?.lowfruit_keywords?.json_data?.data?.include_any_keywords !== undefined ? v?.lowfruit_keywords?.json_data?.data?.include_any_keywords?.map((v:any)=>{ 
                 return {'title':v,'selected':false}
                }) : [];
            }else{
              this.exclude_any_keywords = v?.lowfruit_keywords?.data?.exclude_fix_keywords !== undefined ? v?.lowfruit_keywords?.data?.exclude_fix_keywords?.map((v:any)=>{ 
               return {'title':v,'selected':false}
              }) : [];
              this.exclude_fix_keywords_backup = v?.lowfruit_keywords?.data?.exclude_fix_keywords !== undefined ? v?.lowfruit_keywords?.data?.exclude_fix_keywords : [];
              this.include_fix_keywords = v?.lowfruit_keywords?.data?.include_fix_keywords !== undefined ? v?.lowfruit_keywords?.data?.include_fix_keywords?.map((v:any)=>{ 
                return {'title':v,'selected':false}
               }) : [];
              this.include_any_keywords = v?.lowfruit_keywords?.data?.include_any_keywords !== undefined ? v?.lowfruit_keywords?.data?.include_any_keywords?.map((v:any)=>{ 
                return {'title':v,'selected':false}
               }) : [];
            }
            if (v?.lowfruit_keywords?.data?.hide_keywords != undefined && v?.lowfruit_keywords?.data?.hide_keywords?.length != 0) {
              this.hideKeywordAry = v?.lowfruit_keywords?.data?.hide_keywords
            }
          }
        })
        this.lckrKeyWordData.forEach(e => {
          if (!!e?.lowfruit_keywords) {
            e.lowfruit_keywords.data.suggested = e?.lowfruit_keywords?.data?.suggested?.filter((e: any) => {
              const x = e.split(" ");
              if (!(x.includes("quora") || x.includes("reddit") || x.includes("*"))) {
                return e;
              }
            })
            e.lowfruit_keywords.data.questions = e?.lowfruit_keywords?.data?.questions?.filter((el: any) => {
              const y = el.split(" ");
              if (!(y.includes("quora") || y.includes("reddit") || y.includes("*"))) {
                return el;
              }
            })
          }
        })
        this.getSuggestionAndQuestion('All');
        this.getSuggestionAndQuestion('Suggestion');
        this.getSuggestionAndQuestion('Question');
        this.getSuggestionAndQuestion('PAA');
        this.getSuggestionAndQuestion('Competition');
        this.getSuggestionAndQuestion('Related Searches');
        this.getSuggestionAndQuestion('Hidden');
        this.getSuggestionAndQuestion('Cluster');
        this.changePaginateData(this.activateLink);
  
        this.loading = false;
        if (!!this.lckrKeyWordData) {
          if( this.keyWordType != "list" ){
            // this.gettopicdata();
            this.getClusterDataFromDatabase()
          }
          this.lckrKeyWordData.forEach(e => {
            if (!!e.lowfruit_keywords) {
              this.keyWordCountry = e.lowfruit_keywords.all_data.country
              this.keyWordLanguage = this.keyWordType === 'customkeywords' || this.keyWordType === 'list' ? e.lowfruit_keywords.all_data.langauge : e.lowfruit_keywords.all_data.language;
              this.keyWordName = this.keyWordType === 'customkeywords' ? e.lowfruit_keywords.all_data.reportName : this.keyWordType === 'list' ? e.lowfruit_keywords.all_data.reportName : e.lowfruit_keywords.all_data.keyword;
            }
            if (e.is_completed === false) {
              e?.keyword.forEach((ele: any) => {
                let data = e.json_data.data.analysis.hasOwnProperty(ele);
                if (!data) {
                  this.backupKeyWordArray.push(ele);
                }
              })
              this.completedAnalyse = this.completedAnalyse + e.scraped_keywords;
              this.overAllanalyse = this.overAllanalyse + e.total_keywords;
              this.socket.emit("updater", e.kid);
            }
          })
        }
      } catch (error:any) {
        // this.toastr.error(error.message)
      }
    })
  }
  refreshData() {
    window.location.reload();
  }

  gettopicdata() {
    let keyWordArrays: any = [];
    if (this.keyWordData.length != 0) {
      this.keyWordData.forEach((e: any) => {
        keyWordArrays.push(e.title);
      })
      this.editorService.gettopicdata(keyWordArrays).subscribe((res) => {
        this.loading = false;
        this.newword = res
        if (sessionStorage.getItem("topicsdata")) {
          this.topicloading = true
        }
        else {
          this.topicloading = false
        }
        sessionStorage.setItem("topicsdata", JSON.stringify(this.newword));
        // if (this.panelOpenStatetopic == true) {
        this.displaytopic()
        // }
      })
    }
    // else {
    //   alert("get_keyword_data not found")
    // }
  }

  displaytopic() {
    let topicdatas: any = [];
    topicdatas = sessionStorage.getItem("topicsdata");
    this.topicloading = true;
    if (topicdatas != null) {
      this.topicloading = false
      this.topicData = topicdatas
      this.topicData = JSON.parse(topicdatas).map((topics: string) => {
        let datas = topics.replace(/\"/g, "")
        return { datas, isSelected: false }
      });
      this.backupTopicData = JSON.parse(topicdatas).map((topics: string) => {
        let datas = topics.replace(/\"/g, "")
        return { datas, isSelected: false }
      });

    }
    else {
      this.topicloading = false
      if (this.newword.length > 0) {
        this.topicData = this.newword
        this.topicData = this.topicData.map(topics => {
          let datas = topics.replace(/\"/g, "")
          return { datas, isSelected: false }
        })
      }
    }
  }
  filterTopic() {
    this.topicData = this.backupTopicData.filter(el => el.datas.toLowerCase().search(this.searchTopic.toLowerCase()) >= 0)
  }

  openPopupover(data: string) {
    this.openPopup = true;
    this.title = data;
  }
  showKey(data: any) {
    if (data.isPaa) {
      return 'PAA';
    } else if (data.isRelated) {
      return 'Related';
    } else {
      return ''
    }
  }
  assignMatMenu(arg: string) {
    this.matMenuName = arg
    this.matMenuArg = arg;
    switch (arg) {
      case 'Status':
        this.matMenuItemArray = this.statusMenuArray;
        break;
      case 'Intent':
        this.matMenuItemArray = this.intentMenuArray;
        break;
      case 'Weak Spots':
        this.matMenuItemArray = this.weakSpotMenuArray;
        break;
      case 'Forums':
        this.matMenuItemArray = this.formusMenuArray;
        break;
      default:
        break;
    }
  }

  isPopupClose(data: any) {
    this.openPopup = data
  }
  voluman_data: any = []
  getSuggestionAndQuestion(arg: string) {
    let newPaginateData: any = [];
    this.lckrKeyWordData.sort((b, a) => new Date(a?.created_on).getTime() - new Date(b?.created_on).getTime());
    if (arg == 'Suggestion') {
      // let finalEntryNames: any = []
      // let entryNames: any = [];
      this.lckrKeyWordData.forEach(e => {
        // entryNames = [];
        if (e.lowfruit_keywords) {
          newPaginateData = [...e.lowfruit_keywords.data.suggested];
        }
        // if (e.json_data?.data?.analysis) {
        //   for (const key in e.json_data.data.analysis) {
        //     entryNames.push(key);
        //   }
        //   Object.values(e.json_data.data.analysis).forEach((object: any, index: any) => {
        //     let count = 0;
        //     let entry: any = {};
        //     object.forEach((e: any) => {
        //       let temp: any = {}
        //       temp = getSerp(e);
        //       entry[e.position] = temp;
        //       function getSerp(row: any) {
        //         let serp: any = [undefined];
        //         for (const key in row) {
        //           if (row[key] === true) {
        //             count = count + 1;
        //             if (key == 'web 2.0' || key == 'socialmedia' || key == 'filetype') {
        //               count = count - 1;
        //             }
        //             if (!serp || serp[0] == undefined) {
        //               serp = [];
        //             }
        //             if(key==="lowda" && row.data_lowda?.da>30){
        //               count = count - 1;
        //             }
        //             serp.push({ key, da: row.data_lowda })
        //           }
        //         }
        //         return { serp: serp, domain: row.domain };
        //       }
        //     })
        //     entryNames[index] = {
        //       keyword: entryNames[index], entry: entry, weakSpotCount: count, LDA: null,
        //       data: e.json_data?.data?.search_result.filter((el: any) => {
        //         let dataArr: any = [];
        //         if (el[entryNames[index]]) {
        //           dataArr = Object.values(el).map(element => {
        //             return element
        //           })
        //           return dataArr;
        //         } else {
        //           return false
        //         }
        //       })
        //     }
        //   });
        //   entryNames.forEach((e: any) => {
        //     finalEntryNames.push(e)
        //   });
        // }
        // newPaginateData = newPaginateData.map((e: any) => {
        //   let positions = finalEntryNames.find((n: any) => n.keyword == e);
        //   let sortedPositions: any = [];
        //   if (positions) {
        //     let allKeys = Object.keys(positions.entry);
        //     allKeys.sort((a: any, b: any) => {
        //       return Number(a) - Number(b)
        //     });
        //     allKeys.forEach(key => {
        //       let LDA = positions.entry[key].serp.find((elem: any) => {
        //         if (!!elem && !!elem?.key) {
        //           return elem.key == "lowda"
        //         } else {
        //           return null;
        //         }
        //       });
        //       if (!!LDA && !!LDA?.da?.da) {
        //         if (positions.LDA === null || LDA.da.da < positions.LDA) {
        //           positions.LDA = LDA.da.da
        //         }
        //       }
        //       sortedPositions.push({ position: key, serp: positions.entry[key] });
        //     });
        //   }
        //   let findVol = this.voluman_data?.find((v: any) => v?.keyword == e);
        //   let vol = findVol?.vol;
        //   let cpc = findVol?.cpc;
        //   return { title: e, isChecked: false, keywordPosition: sortedPositions, running: e?.runnning, weakSpotCount: positions?.weakSpotCount, data: positions?.data, vol: vol, cpc: cpc, LDA: positions?.LDA }
        // });
        // newPaginateData.forEach((e: any, index: number) => {
        //   if (!!e.data) {
        //     e.data[0][e.title].forEach((s: any, index: number) => {
        //       s["serp"] = e.keywordPosition[index]?.serp
        //     });
        //   }
        // })
      })
      this.suggestionPaginateData = this.allPaginateData.filter(e => newPaginateData.includes(e.title));
      newPaginateData = []
    } else if (arg == 'Question') {
      // let finalEntryNames: any = []
      // let entryNames: any = [];
      this.lckrKeyWordData.forEach(e => {
        // entryNames = [];
        if (e.lowfruit_keywords) {
          newPaginateData = [...e.lowfruit_keywords.data.questions];
        }
        // if (e.json_data?.data?.analysis) {
        //   for (const key in e.json_data.data.analysis) {
        //     entryNames.push(key);
        //   }
        //   Object.values(e.json_data.data.analysis).forEach((object: any, index: any) => {
        //     let count = 0;
        //     let entry: any = {};
        //     object.forEach((e: any) => {
        //       let temp: any = {}
        //       temp = getSerp(e);
        //       entry[e.position] = temp;
        //       function getSerp(row: any) {
        //         let serp: any = [undefined];
        //         for (const key in row) {
        //           if (row[key] === true) {
        //             count = count + 1;
        //             if (key == 'web 2.0' || key == 'socialmedia' || key == 'filetype') {
        //               count = count - 1;
        //             }
        //             if (!serp || serp[0] == undefined) {
        //               serp = [];
        //             }
        //             if(key==="lowda" && row.data_lowda?.da>30){
        //               count = count - 1;
        //             }
        //             serp.push({ key, da: row.data_lowda })
        //           }
        //         }
        //         return { serp: serp, domain: row.domain };
        //       }
        //     })
        //     entryNames[index] = {
        //       keyword: entryNames[index], weakSpotCount: count, entry: entry, LDA: null,
        //       data: e.json_data?.data?.search_result.filter((el: any) => {
        //         let dataArr: any = [];
        //         if (el[entryNames[index]]) {
        //           dataArr = Object.values(el).map(element => {
        //             return element
        //           })
        //           return dataArr;
        //         } else {
        //           return false
        //         }
        //       })
        //     }
        //   })
        //   entryNames.forEach((e: any) => {
        //     finalEntryNames.push(e)
        //   });
        // }
        // newPaginateData = newPaginateData.map((e: any) => {
        //   let positions = finalEntryNames.find((n: any) => n.keyword == e);
        //   let sortedPositions: any = [];
        //   if (positions) {
        //     let allKeys = Object.keys(positions.entry);
        //     allKeys.sort((a: any, b: any) => {
        //       return Number(a) - Number(b)
        //     });
        //     allKeys.forEach(key => {
        //       let LDA = positions.entry[key].serp.find((elem: any) => {
        //         if (!!elem && !!elem?.key) {
        //           return elem.key == "lowda"
        //         } else {
        //           return null;
        //         }
        //       });
        //       if (!!LDA && !!LDA?.da?.da) {
        //         if (positions.LDA === null || LDA.da.da < positions.LDA) {
        //           positions.LDA = LDA.da.da
        //         }
        //       }
        //       sortedPositions.push({ position: key, serp: positions.entry[key] });
        //     });
        //   }
        //   let findVol = this.voluman_data?.find((v: any) => v?.keyword == e);
        //   let vol = findVol?.vol;
        //   let cpc = findVol?.cpc;
        //   return { title: e, isChecked: false, keywordPosition: sortedPositions, weakSpotCount: positions?.weakSpotCount, data: positions?.data, vol: vol, cpc: cpc, LDA: positions?.LDA }
        // });
      })
      // newPaginateData.forEach((e: any, index: number) => {
      //   if (!!e.data) {
      //     e.data[0][e.title].forEach((s: any, index: number) => {
      //       s["serp"] = e.keywordPosition[index]?.serp
      //     });
      //   }
      // })
      // newPaginateData = newPaginateData.sort((a: any, b: any) => {
      //   if (a.weakSpotCount == undefined) {
      //     return 1;
      //   } else if (b.weakSpotCount == undefined) {
      //     return -1;
      //   } else {
      //     return b.weakSpotCount - a.weakSpotCount;
      //   }
      // })
      this.questionsPaginateData = this.allPaginateData.filter(e => newPaginateData.includes(e.title));
    } else if (arg === 'All') {
      let finalEntryNames: any = []
      let entryNames: any = [];
      this.lckrKeyWordData.forEach((e: any) => {
        entryNames = [];
        if (e.lowfruit_keywords) {
          newPaginateData = [...e.lowfruit_keywords.data.suggested, ...e.lowfruit_keywords.data.questions];
        }
        if (e.json_data?.data?.analysis) {
          for (const key in e.json_data.data.analysis) {
            entryNames.push(key);
          }
          Object.values(e.json_data.data.analysis).forEach((object: any, index: any) => {
            let count = 0;
            let entry: any = {};
            object.forEach((e: any,index:any) => {
              e.position = index + 1
              let temp: any = {}
              let getSerp = (row: any) => {
                let serp: any = [undefined];
                let checkCustomdomain = this.settingsData?.customDomain?.includes(row.domain);

                let checkStatus = Object.values(row).some(item => item === true);
                if (!checkStatus) {
                  if (checkCustomdomain) {
                    count = count + 1;
                  }
                } else {
                  for (const key in row) {
                    if (row[key] === true) {
                      count = count + 1;
                      if (key == 'web 2.0' || key == 'socialmedia' || key == 'filetype') {
                        count = count - 1;
                      }
                      if (checkCustomdomain) {
                        if (key === "lowda" || key === "reddit" || key === "forum" || key === "quora") {
                          count = count;
                        } else {

                          count = count + 1;
                        }
                      }

                      if (!serp || serp[0] == undefined) {
                        serp = [];
                      }
                      if (key === "lowda" && row.data_lowda?.da > this.settingsData.maxDa) {
                        count = count - 1;
                      }
                      if(serp.length == 0){
                        serp.push({ key, da: row.data_lowda })
                      }else if((serp.length > 0) && (serp[0]?.key == "lowda" || serp[0]?.key == "forum") && (key == "lowda" || key == "forum")){
                        serp.push({ key, da: row.data_lowda })
                        if (key === "lowda" && row.data_lowda?.da < this.settingsData.maxDa) {
                          count = count - 1;
                        }
                      }else if(key == "reddit" || key == "quora"){
                        count = count - 1;
                      }
                    }
                  }
                }
                return { serp: serp, domain: row.domain, isCustomDomain: this.settingsData?.customDomain?.includes(row.domain) ? true : false, isMySites: this.settingsData?.mySites?.includes(row.domain) ? true : false };
              }
              temp = getSerp(e);
              entry[e.position] = temp;
            });
            entryNames[index] = {
              keyword: entryNames[index], entry: entry, running: e.running, domain: object.domain, weakSpotCount: count, LDA: null, HDA: null,
              data: e.json_data?.data?.search_result.filter((el: any) => {
                let dataArr: any = [];
                if (el[entryNames[index]]) {
                  dataArr = Object.values(el).map(element => {
                    return element
                  })
                  return dataArr;
                } else {
                  return false
                }
              })
            }
          })

          entryNames.forEach((e: any) => {
            finalEntryNames.push(e)
          });
        }
      })
      newPaginateData = newPaginateData.map((e: any) => {
        let positions = finalEntryNames.find((n: any) => n.keyword == e);
        let sortedPositions: any = [];
        if (positions) {
          let allKeys = Object.keys(positions.entry);
          allKeys.sort((a: any, b: any) => {
            return Number(a) - Number(b)
          });
          allKeys.forEach(key => {
            let LDA = positions.entry[key].serp.find((elem: any) => {
              if (!!elem && !!elem?.key) {
                return elem.key == "lowda"
              } else {
                return null;
              }
            });
            if (!!LDA && !!LDA?.da?.da) {
              if (positions.LDA === null || LDA.da.da < positions.LDA) {
                if (LDA.da.da > this.settingsData.maxDa) {
                  positions.LDA = null
                } else {
                  positions.LDA = LDA.da.da;
                }
              }
            }

            if (!!LDA && !!LDA?.da?.da) {
              if (positions.HDA === null || LDA.da.da > positions.HDA) {
                if (LDA.da.da > this.settingsData.maxDa) {
                  positions.HDA = null;
                } else {
                  positions.HDA = LDA.da.da;
                }
                // positions.HDA = LDA.da.da
              }
            }


            sortedPositions.push({ position: key, serp: positions.entry[key] });
          });
        }
        let findVol = this.voluman_data?.find((v: any) => v?.keyword == e);
        let vol = findVol?.vol;
        let cpc = findVol?.cpc;
        return { title: e, isChecked: false, keywordPosition: sortedPositions, running: positions?.running, weakSpotCount: positions?.weakSpotCount, data: positions?.data, vol: vol, cpc: cpc, LDA: positions?.LDA, HDA: positions?.HDA }
      });
      newPaginateData.forEach((e: any, index: number) => {
        if (!!e.data) {
          e.data[0][e.title].forEach((s: any, index: number) => {
            s["serp"] = e.keywordPosition[index]
          });
        }
      });
      this.allPaginateData = newPaginateData;
    } else if (arg === 'PAA') {
      if (this.lckrKeyWordData.length > 0) {
        let paaData1: any = [];
        this.lckrKeyWordData.forEach((e: any) => {
          if (!!e) {
            e.json_data?.data?.paa.map((e: any) => {
              Object.values(e).forEach((arg: any) => {
                arg.forEach((element: any) => {
                  paaData1.unshift({ ...element, isPaa: true, keyWord: Object.keys(e) })
                });
              })
            });
          }
        })
        let result = paaData1.filter(
          (item: any, index: any) => index === paaData1.findIndex(
            (other: any) => item.Question === other.Question
          ));
        newPaginateData = result.map((e: any) => {
          return { title: e.Question, isPaa: true, keyWord: e.keyWord }
        });
        this.paaPaginateData = newPaginateData;
      }
    } else if (arg === 'Competition') {
      if (this.lckrKeyWordData.length > 0) {
        let domainData: any = [];
        this.lckrKeyWordData.forEach(e => {
          if (!!e.json_data?.data?.domain) {
            e.json_data.data.domain.forEach((el: any) => {
              domainData.unshift(el)
            });
          }
        });
        let result = domainData.filter(
          (item: any, index: any) => index === domainData.findIndex(
            (other: any) => item === other
          ));
        newPaginateData = result.map((e: any) => {
          return { title: e, isChecked: false }
        })
        this.competitionPaginateData = newPaginateData;
      } else {
        this.competitionPaginateData = [];
      }
    } else if (arg === 'Related Searches') {
      if (this.lckrKeyWordData.length > 0) {
        let relatedData: any = []
        this.lckrKeyWordData.forEach((e: any) => {
          if (!!e) {
            e.json_data?.data?.related.map((e: any) => {
              Object.values(e).forEach((arg: any) => {
                arg.forEach((element: any) => {
                  relatedData.unshift({ title: element, isPaa: true, keyWord: Object.keys(e) })
                });
              })
            });
          }
        })
        let result = relatedData.filter(
          (item: any, index: any) => index === relatedData.findIndex(
            (other: any) => item.title === other.title
          ));
        newPaginateData = result;
        this.keyWordData = newPaginateData;
        this.backupKeyWordData = newPaginateData;
        this.relatedSearchedPaginateData = newPaginateData;
      }
    } else if (arg === 'Hidden') {
      this.paginateData = [];
      this.keyWordData = [];
      this.hideArray = [];
      if (this.hideKeywordAry?.length > 0) {
        this.hideArray.forEach(e => {
          e.isChecked = false;
        });
        this.hiddenPaginateData = this.hideArray;
        this.allPaginateData.forEach((v: any) => {
          if (this.hideKeywordAry?.includes(v.title)) {
            this.paginateData.push(v);
            this.keyWordData.push(v);
            this.hideArray.push(v);
            this.backupHideArr.push(v.title);
          }
        })
      } else {
        this.keyWordData = [];
        this.hiddenPaginateData = [];
        this.backupKeyWordData = [];
      }
    } else if (arg === 'Cluster') {
      this.clusterData = this.allPaginateData;
    }
    else {
      this.paginateData = [];
      this.keyWordData = [];
      this.backupKeyWordData = [];
      this.filterData();
    }

  }

  changePaginateData(arg: string, optionalArg?: string, loadingArg?: string) {
    if (!!optionalArg && optionalArg === 'resetPagination') {
      this.page = 1;
      this.jumpToPageCount = this.page;
    }
    if (arg == 'All') {
      this.paginateData = this.allPaginateData;
      this.keyWordData = this.allPaginateData;
      this.backupKeyWordData = this.allPaginateData;
      this.filterData();
    } else if (arg == "Suggestion") {
      this.paginateData = this.suggestionPaginateData;
      this.keyWordData = this.suggestionPaginateData;
      this.backupKeyWordData = this.suggestionPaginateData;
      this.filterData();
    } else if (arg == 'Question') {
      this.paginateData = this.questionsPaginateData;
      this.keyWordData = this.questionsPaginateData;
      this.backupKeyWordData = this.questionsPaginateData;
      this.filterData();
    } else if (arg == 'PAA') {
      this.paginateData = this.paaPaginateData;
      this.keyWordData = this.paaPaginateData;
      this.backupKeyWordData = this.paaPaginateData;
      this.filterData();
    } else if (arg === 'Competition') {
      this.keyWordData = this.competitionPaginateData;
      this.backupKeyWordData = this.competitionPaginateData;
      this.competitionPaginateData = this.competitionPaginateData;
      this.filterData();
    } else if (arg === 'Related Searches') {
      this.keyWordData = this.relatedSearchedPaginateData;
      this.backupKeyWordData = this.relatedSearchedPaginateData;
      this.filterData();
    } else if (arg === 'Hidden') {
      if (this.hideArray.length > 0) {
        this.hideArray.forEach(e => {
          e.isChecked = false;
        });
        this.hiddenPaginateData = this.hideArray;
        this.paginateData = this.hideArray;
        this.keyWordData = this.hideArray;
        this.filterData();
      } else {
        this.paginateData = [];
        this.keyWordData = [];
        this.backupKeyWordData = [];
        this.filterData()
      }
    } else if (arg === 'Cluster') {
      if (this.clusteredData.length > 0) {
        this.paginateData = this.clusteredData;
        this.keyWordData = this.clusteredData;
        this.backupKeyWordData = this.clusteredData;
        this.filterData();
      } else {
        this.paginateData = [];
        this.keyWordData = [];
        this.backupKeyWordData = [];
        this.filterData()
      }
    } else {
      this.paginateData = [];
      this.keyWordData = [];
      this.backupKeyWordData = [];
      this.filterData()
    }
  }
  activeLink(data: string) {
    this.activateLink = data;
  }

  reset(title: string) {
    title === 'Include' ? this.includeWord = new FormControl('') : this.excludeWord = new FormControl('')
  }
  buttonState() {
    return !this.keyWordData?.some(_ => _.isChecked);
  }

  addWord(title: string) {
    if (title === 'Include') {
      this.includedWords.indexOf(this.includeWord.value || '') === -1 && this.includeWord.value !== '' ? this.includedWords.push(this.includeWord.value || '') : '';
    } else {
      this.excludedWords.indexOf(this.excludeWord.value || '') === -1 && this.excludeWord.value !== '' ? this.excludedWords.push(this.excludeWord.value || '') : '';
    }
    this.reset(title);
  }

  deleteWord(data: string, title: string) {
    title === 'Include' ? this.includedWords = this.includedWords.filter(i => i !== data) : this.excludedWords = this.excludedWords.filter(e => e !== data)
  }
  topicclear() {

    this.topicData.forEach(element => {
      element.isSelected = false
    })
    this.topicFilter = [];
    let filterdData = this.backupKeyWordData;
    if (this.topicFilter.length > 0) {
      this.topicFilter.forEach((element) => {
        filterdData = filterdData.filter((el: any) => {
          return (el.title.includes(element))
        })
      })
    }
    if (this.checkTopicFlter) {
      this.activeFilterCount = this.activeFilterCount - 1;
    }
    this.checkTopicFlter = false;
    this.paginateData = filterdData;
    this.keyWordData = filterdData;
    this.filterData();
    this.countedWord = this.topicData.filter(e => { return e.isSelected === true }).length
  }

  selectChip(data: any) {
    this.topicData.forEach(element => {
      if (element.datas == data.datas) {
        element.isSelected = !element.isSelected;

        if (element.isSelected == true) {
          this.topicFilter.push(element.datas);
        }
        else {
          this.topicFilter = this.topicFilter.filter(e => {
            return e !== element.datas;
          })
        }
      }
    });
    if (this.topicFilter.length > 0) {
      this.filterData();

    }
    if (this.topicFilter.length > 0) {
      if (!this.checkTopicFlter) {
        this.activeFilterCount = this.activeFilterCount + 1;
      }
      this.checkTopicFlter = true;
    } else {
      if (this.checkTopicFlter) {
        this.activeFilterCount = this.activeFilterCount - 1;
        this.filterData();
      }
      this.checkTopicFlter = false;
    }
    this.paginateData.forEach(e => {
      e.isChecked = false
    });
    this.masterSelected = false;
    this.allSelect = false
    this.countedWord = this.topicData.filter(e => { return e.isSelected === true }).length
  }
  CheckAll() {
    if (this.activateLink === 'All' || this.activateLink == 'Suggestion' || this.activateLink == 'Question' || this.activateLink == 'Hidden') {
      for (let i = 0; i < this.paginateData.length; i++) {
        this.paginateData[i].isChecked = this.allSelect == true ? true : this.masterSelected;
        this.isAllChecked = this.allSelect == true ? true : this.masterSelected;
      }
    } else {
      for (let i = 0; i < this.paginateData.length; i++) {
        this.paginateData[i].isChecked = this.allSelect == true ? true : this.masterSelected;
        this.isAllChecked = this.allSelect == true ? true : this.masterSelected;
      }
      // for (let i = 0; i < this.keyWordData.length; i++) {
      //   this.keyWordData[i].isChecked = this.masterSelected
      // }
    }
  }
  openModel(content:any){
    this.modal.open(content, { centered: true });
  }
  allPageSelect(){
    if(this.activateLink === 'PAA' || this.activateLink == 'Competition' || this.activateLink == 'Related Searches'){
      for (let i = 0; i < this.keyWordData.length; i++) {
        this.keyWordData[i].isChecked = this.allSelect
      }
    }else{

    for (let i = 0; i < this.paginateData.length; i++) {
      this.paginateData[i].isChecked = this.allSelect;
      this.isAllChecked = this.allSelect;
    }
    for (let i = 0; i < this.keyWordData.length; i++) {
      this.keyWordData[i].isChecked = this.allSelect
    }
    if (this.activateLink === 'All' || this.activateLink == 'Suggestion' || this.activateLink == 'Question' || this.activateLink == 'Hidden') {
      for (let i = 0; i < this.paginateData.length; i++) {
        this.paginateData[i].isChecked = this.allSelect == true ? true : this.masterSelected;
        this.isAllChecked = this.allSelect == true ? true : this.masterSelected;
      }
      }
    }
  }

  clearAllFilter() {
    this.loading = true;
    this.weakSpotFilter = [];
    this.forumFilter = [];
    this.intentFilter = [];
    this.statusFilter = [];
    this.serpScoreFilter = [];
    this.searchTopic = "";
    this.displaytopic();
    this.topicclear();
    this.clearFilter('cpc');
    this.clearFilter('vol');
    this.daLessthan10 = false;
    this.daLessthan20 = false;
    this.activeFilterCount = 0;
    this.loading = false;
    this.filterData();
  }
  isAllSelected() {
    if (this.activateLink === 'All' || this.activateLink == 'Suggestion' || this.activateLink == 'Question' || this.activateLink === 'Hidden') {
      this.masterSelected = this.paginateData.every((item: KeywordData) => {
        return item.isChecked == true;
      });
      this.isAllChecked = this.paginateData.some(e => {
        return e.isChecked == true;
      })
    } else {
      this.masterSelected = this.keyWordData.every((item: KeywordData) => {
        return item.isChecked == true;
      });
    }
  }
  onTableDataChange() {
    // this.masterSelected = false;
    if(this.allSelect == false){
      this.masterSelected = false;
    }else{
      this.masterSelected = true;
    }
    this.tableSize = this.activateLink == "Cluster" ? 10 : 50;
    const lastIndex = this.page * this.tableSize;
    const firstIndex = lastIndex + 1 - this.tableSize;
    const pageCount = this.keyWordData?.length / this.tableSize;
    this.count = Math.ceil(pageCount);
    if (this.page == this.count) {
      this.totalData = firstIndex + "-" + this.keyWordData?.length
    } else {
      this.totalData = firstIndex + "-" + lastIndex
    }
    this.paginateData = this.keyWordData?.slice((this.page - 1) * this.tableSize, (this.page - 1) * this.tableSize + this.tableSize);
    this.loading = false;
    if (this.paginateData.length > 0) {
      this.checkStatus = this.paginateData.every(e => e.isChecked);
      if (this.checkStatus) {
        this.masterSelected = true;
      } else {
        this.masterSelected = false;
      }
    }
  }
  getFilteredData() {
    if (this.activateLink === 'Hidden') {
      this.keyWordData = this.backupKeyWordData.filter((e: KeywordData | any) => {
        let key = this.searchText.toLowerCase();
        return (e.title.toLowerCase().search(key) >= 0 && this.backupHideArr.includes(e.title));
      });
    } else if (this.activateLink === 'PAA' || this.activateLink === 'Related Searches') {
      this.keyWordData = this.paginateData.filter((e: KeywordData | any) => {
        let key = this.searchText.toLowerCase();
        return (e.keyWord[0].toLowerCase().search(key) >= 0);
      });
    } else {
      this.keyWordData = this.backupKeyWordData.filter((e: KeywordData | any) => {
        let key = this.searchText.toLowerCase();
        return (e.title.toLowerCase().search(key) >= 0 && !this.backupHideArr.includes(e.title) && e.title.split(" ")[e.title.split(" ").length - 1] !== 'reddit' && e.title.split(" ")[e.title.split(" ").length - 1] !== 'quora');
      });
    }
    this.masterSelected = false;
    this.allSelect = false
    this.CheckAll();
    this.onTableDataChange();
  }

  filterValue(arg: string, num1: string, num2: string) {
    this.filterData()
  }
  clearFilter(filterName: string) {
    if (filterName == "cpc") {
      this.cpcFilter = {
        min: "",
        max: ""
      }
      if (this.checkCpcFilter) {
        this.activeFilterCount = this.activeFilterCount - 1;
      }
      this.checkCpcFilter = false;
    }

    if (filterName == "vol") {
      this.volFilter = {
        min: "",
        max: ""
      }
      if (this.checkVolFilterAvailable) {
        this.activeFilterCount = this.activeFilterCount - 1;
      }
      this.checkVolFilterAvailable = false;

    }
    this.filterData()
  }

  openModal() {
    this.display = "block";
  }

  onDelete() {
    const check = this.keyWordData.every(e => e.isChecked === true);
    if (check) {
      this.keyWordData.length = 0;
      this.onTableDataChange();
      this.masterSelected = false;
      this.allSelect = false
    } else {
      this.keyWordData.forEach((e, index) => {
        if (e.isChecked) {
          this.keyWordData.splice(index, 1);
          this.onTableDataChange();
        }
      })
    }
    this.modal.dismissAll();
  }
  keyword_id: any
  performSerpExtract(analyseArr?: any[], keyword?: string, arg?: string) {
    let keyWordArray: any = [];
    this.keyWordArray = [];
    this.waiting8MinutesArray = this.waiting8MinutesArray.filter((v: any) => v != keyword);
    if (!!analyseArr && analyseArr?.length > 0) {
      analyseArr.forEach(e => {
        if (e.keywordPosition && e.keywordPosition.length == 0) {
          keyWordArray.push(e.title);
          this.backupKeyWordArray.push(e.title)
        }
      })
    } else if (arg === "retryAll") {
      this.waiting8MinutesArray.forEach((e: any) => {
        keyWordArray.push(e);
        this.backupKeyWordArray.push(e)
      })
    }
    else if (keyword != "" && keyword != undefined) {
      keyWordArray.push(keyword);
      this.backupKeyWordArray = [];
      this.waiting8MinutesBackupArray.push(keyword);
      this.waiting8MinutesArray.splice(this.waiting8MinutesArray.indexOf(keyword), 1);
    }
    else {
      this.keyWordData.forEach((e: any) => {
        if (e.isChecked) {
          keyWordArray.push(e.title);
          this.backupKeyWordArray.push(e.title)
        }
      })
    }

    this.editorService.addKeyWordData({
      "uid": this.uid,
      "lid": this.keyWordId,
      "keywords": keyWordArray,
      "country": this.keyWordCountry,
      "language": this.keyWordLanguage
    }).subscribe((res: any) => {
      if (res?.error) {
        this.toastr.error(res?.error)
        this.backupKeyWordArray = [];
        this.waiting8MinutesBackupArray = [];
        this.keyWordArray = [];
        this.masterSelected = false;
        this.allSelect = false;
        this.keyWordData.forEach((e: any) => {
          if (e.isChecked) {
            e.isChecked = false
          }
        })
      }
      this.keyword_id = res?.keyword_id
      this.keyWordData.forEach((e: any) => {
        e.isChecked = false
      })
      this.masterSelected = false;
      this.allSelect = false;
      this.isAllChecked = false;
      this.socket.emit("updater", res.keyword_id);
      // this.waiting8MinutesArray = [];
    })
  }
  toggleFilter(matMenuArg: string, item: string, event: MatSlideToggleChange) {
    if (this.activateLink !== 'Competition') {
      if (matMenuArg == "Weak Spots" && KeyWord.weakSpotMenuArray.includes(item)) {
        this.weakSpotFilter = [];
        if (event.checked) {
          if (!this.weakSpotFilter.includes(item)) {
            this.weakSpotFilter.push(item);
          }
        }
        else {
          this.weakSpotFilter = this.weakSpotFilter.filter(e => {
            return e !== item;
          })
          // this.activeFilterCount = this.activeFilterCount - this.weakSpotFilter.length;

        }
      }

      else if (matMenuArg == "Forums" && KeyWord.formusMenuArray.includes(item)) {
        if (event.checked) {
          if (!this.forumFilter.includes(item)) {
            this.forumFilter.push(item);
          }
          // this.activeFilterCount = this.activeFilterCount + this.forumFilter.length

        }
        else {
          this.forumFilter = this.forumFilter.filter(e => {
            return e !== item;
          })
          // this.activeFilterCount = this.activeFilterCount - this.forumFilter.length

        }
      }
      if (matMenuArg == "Intent" && KeyWord.intentMenuArray.includes(item)) {
        if (event.checked) {
          if (!this.intentFilter.includes(item)) {
            this.intentFilter.push(item);
          }
          // this.activeFilterCount = this.activeFilterCount + this.intentFilter.length
        }
        else {
          this.intentFilter = this.intentFilter.filter(e => {
            return e !== item;
          })
          // this.activeFilterCount = this.activeFilterCount - this.intentFilter.length
        }
      }
      if (matMenuArg == "Status" && KeyWord.statusMenuArray.includes(item)) {
        if (event.checked) {
          if (!this.statusFilter.includes(item)) {
            this.statusFilter.push(item);
          }
          // this.activeFilterCount = this.activeFilterCount + this.statusFilter.length

        }
        else {
          this.statusFilter = this.statusFilter.filter(e => {
            return e !== item;
          })
          // this.activeFilterCount = this.activeFilterCount - this.statusFilter.length
        }
      }
      if (matMenuArg == "SERP Score" && KeyWord.serpScoreMenuArray.includes(item)) {
        if (event.checked) {
          if (!this.serpScoreFilter.includes(item)) {
            this.serpScoreFilter.push(item);
          }
          // this.activeFilterCount = this.activeFilterCount + this.statusFilter.length

        }
        else {
          this.serpScoreFilter = this.serpScoreFilter.filter(e => {
            return e !== item;
          })
          // this.activeFilterCount = this.activeFilterCount - this.statusFilter.length
        }
      }
      this.filterData();
      // this.activeFilterCount = this.activeFilterCount + this.weakSpotFilter.length + this.forumFilter.length
      //   + this.intentFilter.length + this.statusFilter.length;
    }
  }

  countAll() {
    let lengthCounter = this.backupKeyWordData;
    this.allPaginateData = lengthCounter.filter(e => !this.backupHideArr.includes(e.title));
  }
  backupFilterData : any = []
  filterData(filterArg?: string) {
    this.loading = true
    this.allSelect = false
    this.backupKeyWordData.forEach(e => e.isChecked = false)
    this.backupFilterData = this.backupKeyWordData;
    let filterdData = this.backupKeyWordData;

    this.allLength = this.suggestionPaginateData.length + this.questionsPaginateData.length;
    this.suggestionLength = this.suggestionPaginateData.length;
    this.questionLength = this.questionsPaginateData.length;
    if (this.daLessthan10) {
      filterdData = filterdData.filter(e => {
        return e.HDA !== null && e.HDA <= 10
      })
    }
    if (this.daLessthan20) {
      filterdData = this.backupKeyWordData;
      filterdData = filterdData.filter(e => {
        return e.HDA !== null && e.HDA <= 20
      })
    }
    if ((!!filterArg && filterArg === "SearchFilter") || this.searchText !== "") {
      if (this.activateLink !== "Cluster") {
        if (this.activateLink === 'Hidden') {
          filterdData = filterdData.filter((e: KeywordData | any) => {
            let key = this.searchText.toLowerCase();
            return (e.title.toLowerCase().search(key) >= 0 && this.backupHideArr.includes(e.title));
          });
        } else if (this.activateLink === 'PAA' || this.activateLink === 'Related Searches') {
          filterdData = filterdData.filter((e: KeywordData | any) => {
            let key = this.searchText.toLowerCase();
            return (e.keyWord[0].toLowerCase().search(key) >= 0);
          });
        } else {
          filterdData = filterdData.filter((e: KeywordData | any) => {
            let key = this.searchText.toLowerCase();
            return (e.title.toLowerCase().search(key) >= 0 && !this.backupHideArr.includes(e.title) && e.title.split(" ")[e.title.split(" ").length - 1] !== 'reddit' && e.title.split(" ")[e.title.split(" ").length - 1] !== 'quora');
          });
        }
      } else {
        filterdData = filterdData.filter((e: KeywordData | any) => {
          let key = this.searchText.toLowerCase();
          return (e.HighestVolKey.title.toLowerCase().search(key) >= 0);
        });
      }
    }
    if (this.backupHideArr.length > 0) {
      this.allLength = this.allPaginateData.filter(el => {
        return !this.backupHideArr.includes(el.title);
      }).length;
      this.suggestionLength = this.suggestionPaginateData.filter((el:any) => {
        return !this.backupHideArr.includes(el.title);
      }).length;
      this.questionLength = this.questionsPaginateData.filter((el:any) => {
        return !this.backupHideArr.includes(el.title);
      }).length;
    }
    if (this.hideArray.length > 0) {
      filterdData = filterdData.filter(e => !this.backupHideArr.includes(e.title));
    }
    if(this.exclude_fix_keywords_backup.length != 0){
      this.exclude_fix_keywords_backup.forEach((v:any)=>{
        this.allPaginateData = this?.allPaginateData.filter((el:any) => {
          if(el?.title?.toUpperCase()?.indexOf(v.toUpperCase()) !== -1 || this.backupHideArr.includes(el.title) ){
          }else{return el} 
        });
        this.suggestionPaginateData = this?.suggestionPaginateData.filter((el:any) => {
          if(el?.title?.toUpperCase()?.indexOf(v.toUpperCase()) !== -1 || this.backupHideArr.includes(el.title) ){
          }else{return el} 
        });
        this.questionsPaginateData = this?.questionsPaginateData.filter((el:any) => {
          if(el?.title?.toUpperCase()?.indexOf(v.toUpperCase()) !== -1 || this.backupHideArr.includes(el.title) ){
          }else{return el} 
        });
      })

      this.exclude_fix_keywords_backup.forEach((a:any)=>{
        filterdData = filterdData.filter((e:any) => {
         if(e?.title?.toUpperCase()?.indexOf(a.toUpperCase()) !== -1){
         }else{return e} 
        });
      })
      this.backupFilterData = filterdData
      this.allLength = this.allPaginateData.length
      this.suggestionLength = this.suggestionPaginateData.length
      this.questionLength = this.questionsPaginateData.length
    }
    if (this.activateLink === "Hidden") {
      filterdData = this.hideArray;
      this.paginateData = filterdData;
      this.keyWordData = filterdData;
    }

    if (this.intentFilter.length > 0) {
      if (this.intentFilter.includes('High - intent')) {
        filterdData = filterdData.filter((el: any) => {
          return (el.title.includes('best') || el.title.includes('review') || el.title.includes('free'))
        })
      }

      if (this.intentFilter.includes("Pre - Purchase")) {
        filterdData = filterdData.filter((el: any) => {
          return (el.title.includes('best') || el.title.includes('review') || el.title.includes('buy') || el.title.includes('discounts'))
        })
      }
      if (this.intentFilter.includes("Post - Purchase")) {
        filterdData = filterdData.filter((el: any) => {
          return (el.title.includes('problem') || el.title.includes('warrenty') || el.title.includes('broken') || el.title.includes('clean'))
        })
      }
      if (this.intentFilter.includes("Comparision")) {
        filterdData = filterdData.filter((el: any) => {
          return (el.title.includes('vs') || el.title.includes('compare') || el.title.includes('comparision') || el.title.includes('alternative') || el.title.includes('alternatives') || el.title.includes('difference') || el.title.includes('compared to'))
        })
      }

    }
    if (this.statusFilter.length > 0) {
      if (this.statusFilter.includes('Analyzed')) {
        filterdData = filterdData.filter((el: any) => {
          return (!!el.keywordPosition && el.keywordPosition.length > 0)
        })
      }
      if (this.statusFilter.includes('Not analyzed')) {
        filterdData = filterdData.filter((el: any) => {
          return (!el.keywordPosition || el.keywordPosition.length <= 0)
        })
      }
    }
    if (this.weakSpotFilter.length > 0) {
      if (this.weakSpotFilter.includes('At least 1 (in top 10)')) {
        filterdData = filterdData.filter((el: any) => {
          let slicedData = el.keywordPosition.slice(0, 10);
          let hasSerp = slicedData.filter((keyword: any) => {
            let serp = keyword.serp.serp.filter((el: any) => {
              return ((el === 'quora' || el === 'reddit' || el === 'forum') || (el?.key === 'quora' || el?.key === 'reddit' || el?.key === 'forum') || keyword?.serp?.isCustomDomain || (el?.key === "lowda" && el?.da?.da < this.settingsData.maxDa));
            })
            return !serp || (serp.length > 0)
          })
          if (hasSerp && hasSerp.length > 0) {
            return true;
          }
          else {
            return false;
          }
        });
      }

      if (this.weakSpotFilter.includes('At least 1 (in top 3)')) {
        filterdData = filterdData.filter((el: any) => {
          let slicedData = el.keywordPosition.slice(0, 3);
          let hasSerp = slicedData.filter((keyword: any) => {
            let serp = keyword.serp.serp.filter((el: any) => {
              return ((el === 'quora' || el === 'reddit' || el === 'forum') || (el?.key === 'quora' || el?.key === 'reddit' || el?.key === 'forum') || keyword?.serp?.isCustomDomain || (el?.key === "lowda" && el?.da?.da < this.settingsData.maxDa));
            })
            return !serp || (serp.length > 0);
          })
          if (hasSerp && hasSerp.length > 0) {
            return true;
          }
          else {
            return false;
          }
        });
      }

      if (this.weakSpotFilter.includes('At least 1 (with Low DA)')) {
        filterdData = filterdData.filter((el: any) => {
          let hasSerp = el.keywordPosition.filter((keyword: any) => {
            let serp = keyword.serp.serp.filter((el: any) => {
              return ((el === 'lowda' || el?.key === 'lowda') && el?.da?.da < this.settingsData.maxDa);
            })
            return !serp || (serp.length > 0);
          })
          if (hasSerp && hasSerp.length > 0) {
            return true;
          }
          else {
            return false;
          }
        });
      }

      if (this.weakSpotFilter.includes('No weak spots')) {
        const finalFiltered = filterdData.filter((e: any) => e.keywordPosition.length > 0);
        filterdData = finalFiltered.filter((el: any) => {
          return el.weakSpotCount === 0;
        })
        // filterdData = finalFiltered.filter((el: any) => {
        //   let hasCustomWS = false;
        //   let hasSerp = el.keywordPosition.filter((keyword: any) => {
        //     if(keyword.serp.isCustomDomain){
        //       hasCustomWS = true
        //     }

        //     let serp = keyword.serp.serp.filter((el: any) => {
        //       return el !== undefined ;
        //     })

        //     return (!serp || serp.length > 0);
        //   })
        //   if (hasSerp && hasSerp.length == 0 && !hasCustomWS) {
        //     return true;
        //   }
        //   else {
        //     return false;
        //   }
        // });
      }
    }

    if (this.forumFilter.length > 0) {
      if (this.forumFilter.includes('At least 1 (in top 3)')) {
        // filterdData = this.backupKeyWordData.slice(0, 3);
        filterdData = filterdData.filter((el: any) => {
          let hasSerp = el.keywordPosition.slice(0,3).filter((keyword: any) => {
            let serp = keyword.serp.serp.filter((el: any) => {
              return el === 'forum' || el?.key === 'forum';
            })
            return serp.length != 0;
          })
          if (hasSerp && hasSerp.length > 0) {
            return true;
          }
          else {
            return false;
          }
        });
      }
    }
    if (this.volFilter) {
      if ((this.volFilter.min !== "" && this.volFilter.min !== undefined && this.volFilter.min !== null) || (this.volFilter.max !== "" && this.volFilter.max !== undefined && this.volFilter.max !== null)) {
        filterdData = filterdData.filter((e: any) => {
          if (this.volFilter.min !== "" && this.volFilter.max == "") {
            return this.volFilter.min <= e.vol;
          }
          if (this.volFilter.max !== "" && this.volFilter.min == "") {
            return e.vol <= this.volFilter.max;
          }
          if (this.volFilter.min !== "" && this.volFilter.max !== "") {
            return this.volFilter.min <= e.vol && e.vol <= this.volFilter.max;
          } else {
            return null;
          }
        });
        if (!this.checkVolFilterAvailable) {
          this.activeFilterCount = this.activeFilterCount + 1;
        }
        this.checkVolFilterAvailable = true;

      }
    }

    if (this.cpcFilter) {
      if ((this.cpcFilter.min !== "" && this.cpcFilter.min !== undefined && this.cpcFilter.min !== null) || (this.cpcFilter.max !== "" && this.cpcFilter.max !== undefined && this.cpcFilter.max !== null)) {
        filterdData = filterdData.filter((e: any) => {

          if (this.cpcFilter.min !== "" && this.cpcFilter.max == "") {
            return this.cpcFilter.min <= e.cpc?.value;
          }
          if (this.cpcFilter.max !== "" && this.cpcFilter.min == "") {
            return e.cpc?.value <= this.cpcFilter.max;
          }
          if ((this.cpcFilter.min !== "" && this.cpcFilter.max !== "")) {
            return this.cpcFilter.min <= e.cpc?.value && e.cpc?.value <= this.cpcFilter.max;
          } else {
            return null;
          }
        });
        if (!this.checkCpcFilter) {
          this.activeFilterCount = this.activeFilterCount + 1;
        }
        this.checkCpcFilter = true;
      }
    }

    if (this.serpScoreFilter.length > 0) {

      filterdData = filterdData.filter((el: any) => {
        if ((el && el.weakSpotCount == 3 && this.serpScoreFilter.includes('Medium')) || (el && el.weakSpotCount >= 4 && this.serpScoreFilter.includes('High')) || (el && (el.weakSpotCount >= 0 && el.weakSpotCount <= 2) && this.serpScoreFilter.includes('Low'))) {
          return true;
        }
        else {
          return false;
        }
      });


    }

    if (this.volUparrow) {
      if (this.activateLink !== "Cluster") {
        filterdData = filterdData.sort((a: any, b: any) => {
          if (a.vol == undefined) {
            return 1
          } else if (b.vol == undefined) {
            return -1;
          } else {
            return a.vol - b.vol;
          }
        })
      } else {
        filterdData = filterdData.sort((a: any, b: any) => {
          if (a.clusterVol == undefined) {
            return 1
          } else if (b.clusterVol == undefined) {
            return -1;
          } else {
            return a.clusterVol - b.clusterVol;
          }
        })
      }
      this.volDownarrow = false;
      this.volUparrow = true;
    } else if (this.volDownarrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.vol == undefined) {
          return -1
        } else if (a.vol == undefined) {
          return 1;
        } else {
          return b.vol - a.vol;
        }
      })
      this.volDownarrow = true;
      this.volUparrow = false;
      // this.onTableDataChange()
    } else if (this.serpUpArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.weakSpotCount == undefined) {
          return 1;
        } else if (b.weakSpotCount == undefined) {
          return -1;
        } else {
          return a.weakSpotCount - b.weakSpotCount;
        }
      })
      this.serpDownArrow = false;
      this.serpUpArrow = true;
      // this.onTableDataChange();
    } else if (this.serpDownArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.weakSpotCount == undefined) {
          return -1;
        } else if (a.weakSpotCount == undefined) {
          return 1;
        } else {
          return b.weakSpotCount - a.weakSpotCount;
        }
      })
      this.serpDownArrow = true;
      this.serpUpArrow = false;
      // this.onTableDataChange()
    } else if (this.weakSpotUpArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.weakSpotCount == undefined) {
          return 1
        } else if (b.weakSpotCount == undefined) {
          return -1;
        } else {
          return a.weakSpotCount - b.weakSpotCount;
        }
      })
      this.weakSpotDownArrow = false;
      this.weakSpotUpArrow = true;
    } else if (this.weakSpotDownArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.weakSpotCount == undefined) {
          return -1
        } else if (a.weakSpotCount == undefined) {
          return 1;
        } else {
          return b.weakSpotCount - a.weakSpotCount;
        }
      })
      this.weakSpotDownArrow = true;
      this.weakSpotUpArrow = false;
      // this.onTableDataChange()
    }else if(this.cpcUpArrow){
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.cpc == undefined) {
          return 1
        } else if (b.cpc == undefined) {
          return -1;
        } else {
          return a?.cpc?.value - b?.cpc?.value;
        }
      })
      this.cpcUpArrow = true;
      this.cpcDownArrow = false;
    }else if(this.cpcDownArrow){
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.cpc == undefined) {
          return -1
        } else if (a.cpc == undefined) {
          return 1;
        } else {
          return b?.cpc?.value - a?.cpc?.value;
        }
      })
      this.cpcDownArrow = true;
      this.cpcUpArrow = false;
    }else if(this.ldaUpArrow){
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.LDA == undefined) {
          return 1
        } else if (b.LDA == undefined) {
          return -1;
        } else {
          return a.LDA - b.LDA;
        }
      })
      this.ldaUpArrow = true;
      this.ldaDownArrow = false;
    }else if(this.ldaDownArrow){
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.LDA == undefined) {
          return -1
        } else if (a.LDA == undefined) {
          return 1;
        } else {
          return b.LDA - a.LDA;
        }
      })
      this.ldaDownArrow = true;
      this.ldaUpArrow = false;
    }else if(this.totalKeywordUpArrow){
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.totalCount == undefined) {
          return 1
        } else if (b.totalCount == undefined) {
          return -1;
        } else {
          return a.totalCount - b.totalCount;
        }
      })
      this.totalKeywordUpArrow = true;
      this.totalKeywordDownArrow = false;
    }else if(this.totalKeywordDownArrow){
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.totalCount == undefined) {
          return -1
        } else if (a.totalCount == undefined) {
          return 1;
        } else {
          return b.totalCount - a.totalCount;
        }
      })
      this.totalKeywordDownArrow = true;
      this.totalKeywordUpArrow = false;
    }else if(this.weakKeywordUpArrow){
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.clusterWeakSpotCount == undefined) {
          return 1
        } else if (b.clusterWeakSpotCount == undefined) {
          return -1;
        } else {
          return a.clusterWeakSpotCount - b.clusterWeakSpotCount;
        }
      })
      this.weakKeywordUpArrow = true;
      this.weakKeywordDownArrow = false;
    }else if(this.weakKeywordDownArrow){
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.clusterWeakSpotCount == undefined) {
          return -1
        } else if (a.clusterWeakSpotCount == undefined) {
          return 1;
        } else {
          return b.clusterWeakSpotCount - a.clusterWeakSpotCount;
        }
      })
      this.weakKeywordDownArrow = true;
      this.weakKeywordUpArrow = false;
    }

    if (this.topicFilter.length > 0) {
      this.topicFilter.forEach((element) => {
        filterdData = filterdData.filter((el: any) => {
          return (el.title.includes(element))
        })
      })
    }
    let fixAry : any = []
    if(this.fixIncludeFixFilter.length != 0){
      filterdData = []
      this.fixIncludeFixFilter.forEach((element:any) => {
        fixAry = this.backupFilterData.filter((el: any) => {
          return (el.title == element)
        })
        filterdData = filterdData.concat(fixAry)
      })
    }
    let ary : any = []
    if(this.fixIncludeAnyFilter.length != 0){
      filterdData = []
      this.fixIncludeAnyFilter.forEach((element:any) => {
        ary = this.backupFilterData.filter((el: any) => {
          return (el.title.includes(element))
        })
        filterdData = filterdData.concat(ary)
      })
    }
    this.paginateData = filterdData;
    this.keyWordData = filterdData;
    this.exportData = filterdData;
    this.onTableDataChange();
    this.loading = false
  }
  success(arg: string) {
    if (arg === 'cpc') {
      if (Number(this.cpcFilter.min) || Number(this.cpcFilter.max) > Number(this.cpcFilter.min)) {
        (document.getElementById('cpcApply') as HTMLButtonElement).disabled = false;
      } else if ((!this.cpcFilter.min) || (this.cpcFilter.max && !this.cpcFilter.min)) {
        (document.getElementById('cpcApply') as HTMLButtonElement).disabled = true;
      }

    }
    if (arg === 'vol') {
      if (Number(this.volFilter.min) || (Number(this.volFilter.max) > Number(this.volFilter.min))) {
        (document.getElementById('volApply') as HTMLButtonElement).disabled = false;
      } else if ((!this.volFilter.min) || (this.volFilter.max && !this.volFilter.min)) {
        (document.getElementById('volApply') as HTMLButtonElement).disabled = true;
      }
    }
  }

  downloadFile() {
    let paa: any = []
    let relatedSearch: any = []
    let compitater: any = []
    // let selectedData: any = [];
    this.paaPaginateData
    this.relatedSearchedPaginateData
    this.competitionPaginateData
    this.lckrKeyWordData

    this.keyWordData.forEach(e => {
      if (e.isChecked) {
        this.exportSelectedData.push(e);

        this.lckrKeyWordData.forEach((l: any) => {
          if (!!l.json_data?.data?.paa) {
            l.json_data.data.paa.forEach((el: any) => {
              if (el[e.title]) {
                paa.push(el)
              }
            });
          }
          if (!!l.json_data?.data?.analysis) {
            if (l.json_data.data.analysis[e.title]) {
              let Obj: any = {}
              let key = e.title
              Obj[key] = l.json_data.data.analysis[e.title]
              compitater.push(Obj)
            }
          }
          if (!!l.json_data?.data?.related) {
            l.json_data.data.related.forEach((el: any) => {
              if (el[e.title]) {
                relatedSearch.push(el)
              }
            });
          }

        })
      }
    });


  this.toastr.success("Excel download process is started");
   let obj = {
      paa : paa,
      relatedSearch : relatedSearch,
      compitater : compitater,
      keyWordName : this.keyWordName ? this.keyWordName : "excel" ,
      selectedExcel : true,
      activateLink : this.activateLink,
      exportSelectedData : this.exportSelectedData
    }
    this.keyWordData.forEach(e => {
      if (e.isChecked) {e.isChecked = false}
    })
    this.editorService.exportSelectedExcel(obj).subscribe((res) => {
      try {
        let dwldLink = document.createElement("a");
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_self");
        }

        dwldLink.setAttribute("href", `https://development.strell.io/TempExcel/strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);
        // dwldLink.setAttribute("href", `http://localhost:4000/TempExcel/strell_${obj.keyWordName}_${new Date().toISOString().split('T')[0]}.xlsx`);
        dwldLink.setAttribute("download", `strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);

        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);


        // window.open(`${environment.apiUrl}/TempExcel/${this.keyWordName}.xlsx`, "_blank");
        // window.open(`http://localhost:4000/TempExcel/${this.keyWordName}.xlsx`, "_blank");
      } catch (error: any) {
        this.toastr.error(error.message)
      }
    })

    this.exportSelectedData = [];
    this.masterSelected = false;
    this.allSelect = false;
    this.keyWordData.forEach(e => {
      e.isChecked = false;
    });
    this.isAllChecked = false;
  }

  downloadAllData() {
    this.toastr.success("Excel download process is started");
    this.excelLoader = true
    let obj = {
      exportData: this.exportData.filter((v: any) => { v.isChecked }),
      keyWordData: this.keyWordData,
      lckrKeyWordData: this.lckrKeyWordData,
      backupHideArr: this.backupHideArr,
      hideArray: this.hideArray,
      keyWordName: this.keyWordName ? this.keyWordName : "excel",
      selectedExcel: false
    }
    this.editorService.exportExcel(obj).subscribe((res) => {
      try {

        let dwldLink = document.createElement("a");
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_self");
        }

        dwldLink.setAttribute("href", `https://development.strell.io/TempExcel/strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);
        // dwldLink.setAttribute("href", `http://127.0.0.1:4000/TempExcel/strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);
        dwldLink.setAttribute("download", `strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);

        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);

        // window.open(`http://localhost:4000/TempExcel/${this.keyWordName}.xlsx`, "_blank");
        this.excelLoader = false
      } catch (error: any) {
        this.toastr.error(error.message)
      }
    })

  }
  downloadSeprateDataExcel() {
    this.keyWordData
    this.toastr.success(`${this.activateLink} Excel download process is started`);
    this.separateExcelLoader = true
    let obj = {
      keyWordData: this.keyWordData.filter((v: any) => v.isChecked),
      keyWordName: this.keyWordName ? this.keyWordName : "excel",
      activateLink : this.activateLink,
      lckrKeyWordData : this.lckrKeyWordData
    }
    if(obj.keyWordData.length == 0){
      obj.keyWordData = this.keyWordData 
    }
    this.keyWordData.forEach(e => {
      if (e.isChecked) {e.isChecked = false}
      })
    this.editorService.exportSeprateDataExcel(obj).subscribe((res:any) => {
      try {

        let dwldLink = document.createElement("a");
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_self");
        }
        dwldLink.setAttribute("href", `https://development.strell.io/TempExcel/strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);
        // dwldLink.setAttribute("href", `http://localhost:4000/TempExcel/${obj.keyWordName}.xlsx`);
        dwldLink.setAttribute("download", `strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);

        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
        this.separateExcelLoader = false;
        // window.open(`http://localhost:4000/TempExcel/${this.keyWordName}.xlsx`, "_blank");
        this.excelLoader = false
      } catch (error: any) {
        this.toastr.error(error.message)
      }
    })

  }

  sortTable(arg: string) {

    if (arg === 'vol') {
      this.volUparrow = !this.volUparrow;
      this.volUparrow == true ? this.volUparrow = true : this.volDownarrow = true;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false

      if (this.volUparrow) {
        this.filterData();
      } else if (this.volDownarrow) {
        this.filterData();
      }
    }else if (arg === 'cpc') {
      this.cpcUpArrow = !this.cpcUpArrow;
      this.cpcUpArrow == true ? this.cpcUpArrow = true : this.cpcDownArrow = true;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.cpcUpArrow) {
        this.filterData();
      } else if (this.cpcDownArrow) {
        this.filterData();
      }
    }else if (arg === 'lda') {
      this.ldaUpArrow = !this.ldaUpArrow;
      this.ldaUpArrow == true ? this.ldaUpArrow = true : this.ldaDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.serpUpArrow) {
        this.filterData();
      } else if (this.ldaDownArrow) {
        this.filterData();
      }
    }else if (arg === 'totalKeyword') {
      this.totalKeywordUpArrow = !this.totalKeywordUpArrow;
      this.totalKeywordUpArrow == true ? this.totalKeywordUpArrow = true : this.totalKeywordDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.totalKeywordUpArrow) {
        this.filterData();
      } else if (this.totalKeywordDownArrow) {
        this.filterData();
      }
    }else if (arg === 'serp') {
      this.serpUpArrow = !this.serpUpArrow;
      this.serpUpArrow == true ? this.serpUpArrow = true : this.serpDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.serpUpArrow) {
        this.filterData();
      } else if (this.serpDownArrow) {
        this.filterData();
      }
    } else if (arg === "weakSpot") {
      this.weakSpotUpArrow = !this.weakSpotUpArrow;
      this.weakSpotUpArrow == true ? this.weakSpotUpArrow = true : this.weakSpotDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.weakSpotUpArrow) {
        this.filterData();
      } else if (this.weakSpotDownArrow) {
        this.filterData();
      }
    }else if (arg === "weakKeyword") {
      this.weakKeywordUpArrow = !this.weakKeywordUpArrow;
      this.weakKeywordUpArrow == true ? this.weakKeywordUpArrow = true : this.weakKeywordDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      if (this.weakKeywordUpArrow) {
        this.filterData();
      } else if (this.weakKeywordDownArrow) {
        this.filterData();
      }
    }
  }
  sortCluster(arg: string, index: number) {
    if (arg === 'vol') {
      this.clusteredData[index].volUparrow = !this.clusteredData[index].volUparrow;
      this.clusteredData[index].volUparrow == true ? this.clusteredData[index].volUparrow = true : this.clusteredData[index].volDownarrow = true;

      // this.volUparrow = !this.volUparrow;
      // this.volUparrow == true ? this.volUparrow = true : this.volDownarrow = true;
      this.clusteredData[index].serpUpArrow = false;
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].weakSpotUpArrow = false;
      this.clusteredData[index].weakSpotDownArrow = false;
      this.clusteredData[index].cpcUparrow = false;
      this.clusteredData[index].cpcDownarrow = false;
      // this.serpUpArrow = false;
      // this.serpDownArrow = false;
      // this.weakSpotUpArrow = false;
      // this.weakSpotDownArrow = false;
      if (this.clusteredData[index].volUparrow) {
        this.sortClusterData(index);
      } else if (this.clusteredData[index].volDownarrow) {
        this.sortClusterData(index);
      }
    }else if (arg === 'cpc') {
      this.clusteredData[index].cpcUparrow = !this.clusteredData[index].cpcUparrow;
      this.clusteredData[index].cpcUparrow == true ? this.clusteredData[index].cpcUparrow = true : this.clusteredData[index].cpcDownarrow = true;

      // this.volUparrow = !this.volUparrow;
      // this.volUparrow == true ? this.volUparrow = true : this.volDownarrow = true;
      this.clusteredData[index].serpUpArrow = false;
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].weakSpotUpArrow = false;
      this.clusteredData[index].weakSpotDownArrow = false;
      this.clusteredData[index].volUparrow = false;
      this.clusteredData[index].volDownarrow = false;
      // this.serpUpArrow = false;
      // this.serpDownArrow = false;
      // this.weakSpotUpArrow = false;
      // this.weakSpotDownArrow = false;
      if (this.clusteredData[index].cpcUparrow) {
        this.sortClusterData(index);
      } else if (this.clusteredData[index].cpcDownarrow) {
        this.sortClusterData(index);
      }
    } else if (arg === 'serp') {
      this.clusteredData[index].serpUpArrow = !this.clusteredData[index].serpUpArrow;
      this.clusteredData[index].serpUpArrow == true ? this.clusteredData[index].serpUpArrow = true : this.clusteredData[index].serpDownArrow = true;
      this.clusteredData[index].volUparrow = false;
      this.clusteredData[index].volDownarrow = false;
      this.clusteredData[index].weakSpotUpArrow = false;
      this.clusteredData[index].weakSpotDownArrow = false;
      this.clusteredData[index].cpcUparrow = false;
      this.clusteredData[index].cpcDownarrow = false;
      if (this.clusteredData[index].serpUpArrow) {
        this.sortClusterData(index);
      } else if (this.clusteredData[index].serpDownArrow) {
        this.sortClusterData(index);
      }
    } else if (arg === "weakSpot") {
      this.clusteredData[index].weakSpotUpArrow = !this.clusteredData[index].weakSpotUpArrow;
      this.clusteredData[index].weakSpotUpArrow == true ? this.clusteredData[index].weakSpotUpArrow = true : this.clusteredData[index].weakSpotDownArrow = true;
      this.clusteredData[index].volUparrow = false;
      this.clusteredData[index].volDownarrow = false;
      this.clusteredData[index].serpUpArrow = false;
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].cpcUparrow = false;
      this.clusteredData[index].cpcDownarrow = false;
      if (this.clusteredData[index].weakSpotUpArrow) {
        this.sortClusterData(index);
      } else if (this.clusteredData[index].weakSpotDownArrow) {
        this.sortClusterData(index);
      }
    }
  }
  sortClusterData(index: number) {
    let filterdData = this.clusteredData[index];
    if (this.clusteredData[index].volUparrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (a.vol == undefined) {
          return 1
        } else if (b.vol == undefined) {
          return -1;
        } else {
          return a.vol - b.vol;
        }
      })
      this.clusteredData[index].volDownarrow = false;
      this.clusteredData[index].volUparrow = true;
    } else if (this.clusteredData[index].volDownarrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (b.vol == undefined) {
          return -1
        } else if (a.vol == undefined) {
          return 1;
        } else {
          return b.vol - a.vol;
        }
      })
      this.clusteredData[index].volDownarrow = true;
      this.clusteredData[index].volUparrow = false;
      // this.onTableDataChange()
    }else if(this.clusteredData[index].cpcUparrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (a.cpc == undefined) {
          return 1
        } else if (b.cpc == undefined) {
          return -1;
        } else {
          return a?.cpc?.value - b?.cpc?.value;
        }
      })
      this.clusteredData[index].cpcDownarrow = false;
      this.clusteredData[index].cpcUparrow = true;
    }else if (this.clusteredData[index].cpcDownarrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (b.cpc == undefined) {
          return -1
        } else if (a.cpc == undefined) {
          return 1;
        } else {
          return b?.cpc?.value - a?.cpc?.value;
        }
      })
      this.clusteredData[index].cpcDownarrow = true;
      this.clusteredData[index].cpcUparrow = false;
      // this.onTableDataChange()
    } else if (this.clusteredData[index].serpUpArrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (a.weakSpotCount == undefined) {
          return 1;
        } else if (b.weakSpotCount == undefined) {
          return -1;
        } else {
          return a.weakSpotCount - b.weakSpotCount;
        }
      })
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].serpUpArrow = true;
      // this.onTableDataChange();
    } else if (this.clusteredData[index].serpDownArrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (b.weakSpotCount == undefined) {
          return -1;
        } else if (a.weakSpotCount == undefined) {
          return 1;
        } else {
          return b.weakSpotCount - a.weakSpotCount;
        }
      })
      this.clusteredData[index].serpDownArrow = true;
      this.clusteredData[index].serpUpArrow = false;
      // this.onTableDataChange()
    } else if (this.clusteredData[index].weakSpotUpArrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (a.weakSpotCount == undefined) {
          return 1
        } else if (b.weakSpotCount == undefined) {
          return -1;
        } else {
          return a.weakSpotCount - b.weakSpotCount;
        }
      })
      this.clusteredData[index].weakSpotDownArrow = false;
      this.clusteredData[index].weakSpotUpArrow = true;
    } else if (this.clusteredData[index].weakSpotDownArrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (b.weakSpotCount == undefined) {
          return -1
        } else if (a.weakSpotCount == undefined) {
          return 1;
        } else {
          return b.weakSpotCount - a.weakSpotCount;
        }
      })
      this.clusteredData[index].weakSpotDownArrow = true;
      this.clusteredData[index].weakSpotUpArrow = false;
      // this.onTableDataChange()
    }
    this.clusteredData[index].cluster = filterdData;
    this.paginateData = this.clusteredData;
    this.getClusterData(index);
  }
  handleHide(isHide: boolean) {
    let tempAry: any = []
    if (this.activateLink === 'All' || this.activateLink === 'Suggestion' || this.activateLink === 'Question') {
      if (isHide) {
        this.keyWordData = this.keyWordData.filter((e, index) => {
          if (e.isChecked) {
            // if (this.backupHideArr.length == 0 || !this.backupHideArr.includes(e.title)) {
            this.hideArray.push(e);
            this.hiddenDataBackupArr.push(e);
            this.backupHideArr.push(e.title);
            tempAry.push(e.title);
            this.hideKeywordAry?.push(e.title)
            // }
          } else {
            return e;
          }
        });
        this.editorService.saveHideKeyword({
          "keywords": tempAry,
          "lid": this.keyWordId,
          "unHide": "false"
        }).subscribe(res => {
          if (res) {

          }
        })
      }
      this.hiddenDataLength = this.hideArray.length;
      if (this.activateLink === 'All') {
        this.changePaginateData('All');
      }
      if (this.activateLink === 'Suggestion') {
        this.changePaginateData('Suggestion');
      }
      if (this.activateLink === 'Question') {
        this.changePaginateData('Question');
      }
      this.masterSelected = false;
      this.allSelect = false;
      this.isAllChecked = false;
      this.changePaginateData('Hidden');
      // this.onTableDataChange();
    } else if (this.activateLink === 'Hidden') {
      let tempAry: any = []
      if (!isHide) {
        this.hideArray = this.hideArray.filter(e => { return !e.isChecked });
        this.backupHideArr = [];
        this.hiddenDataBackupArr = [];
        this.hideKeywordAry = [];
        this.hideArray.forEach(e => {
          this.backupHideArr.push(e.title);
          this.hiddenDataBackupArr.push(e.title);
          this.hideKeywordAry?.push(e.title);
          tempAry.push(e.title)
        })
        this.editorService.saveHideKeyword({
          "keywords": tempAry,
          "lid": this.keyWordId,
          "unHide": "true"
        }).subscribe(res => {
          if (res) {

          }
        })
        this.hiddenDataLength = this.hideArray.length;
        this.changePaginateData('All');
        this.changePaginateData('Suggestion');
        this.changePaginateData('Question');
        this.masterSelected = false;
        this.allSelect = false;
        this.isAllChecked = false;
        this.changePaginateData('Hidden');
      }

    }
  }
  checkDomainlowdaStatus(doamin: any) {
    let flag = false;
    if (doamin && this.lckrKeyWordData?.length > 0) {
      for (let j = 0; j < this.lckrKeyWordData?.length; j++) {
        if (this.lckrKeyWordData[j]?.json_data != undefined) {
          let data = this.lckrKeyWordData[j]?.keyword;
          if (typeof data == "object") {
            let findIndex = data.findIndex((element: any, i: any) =>
              this.lckrKeyWordData[j]?.json_data?.data?.analysis[data[i]]?.some((item: any) => item?.lowda == true && doamin == item?.domain))
            if (findIndex !== -1) {
              return true;
            }
          } else {
            return flag;
          }
        }
      }
      return flag;
    }
    return flag
  }

  linkCopy() {
    var dummy = document.createElement('input');
    //let text = window.location.href;
    // let url = `${window.location.protocol + "//" + window.location.host}/lckr/dashboard/${this.keyWordId}?uid=${this.uid}&theme=${this.theme}&type=${this.keyWordType}`
    let url = `${window.location.protocol + "//" + window.location.host}/lckr/dashboard/${this.keyWordId}?type=${this.keyWordType}`
    document.body.appendChild(dummy);
    dummy.value = url;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    this.toastr.success("Link Copied to clipboard")
  }
  getCredit() {
    let analysisData = this.keyWordData;
    this.highintentLength = analysisData.filter((el: any) => {
      return (el.title.includes('best') || el.title.includes('review') || el.title.includes('free'))
    }).length;
    this.prePurchaseLength = analysisData.filter((el: any) => {
      return (el.title.includes('best') || el.title.includes('review') || el.title.includes('buy') || el.title.includes('discounts'))
    }).length;
    this.postPurchaseLength = analysisData.filter((el: any) => {
      return (el.title.includes('problem') || el.title.includes('warrenty') || el.title.includes('broken') || el.title.includes('clean'))
    }).length;
    this.comparisionLength = analysisData.filter((el: any) => {
      return (el.title.includes('vs') || el.title.includes('compare') || el.title.includes('comparision') || el.title.includes('alternative') || el.title.includes('alternatives') || el.title.includes('difference') || el.title.includes('compared to'))
    }).length;
    this.wholeKeywordReportLength = analysisData.length;
  }
  analyseByIntent(arg: string) {
    this.buttonArg.push(arg);
    let filterData = this.keyWordData
    if (arg === 'High - Intent') {
      filterData = filterData.filter((el: any) => {
        return (el.title.includes('best') || el.title.includes('review') || el.title.includes('free'))
      })
    }

    if (arg === 'Pre - Purchase') {
      filterData = filterData.filter((el: any) => {
        return (el.title.includes('best') || el.title.includes('review') || el.title.includes('buy') || el.title.includes('discounts'))
      })
    }
    if (arg === 'Post - Purchase') {
      filterData = filterData.filter((el: any) => {
        return (el.title.includes('problem') || el.title.includes('warrenty') || el.title.includes('broken') || el.title.includes('clean'))
      })
    }
    if (arg === 'Comparision') {
      filterData = filterData.filter((el: any) => {
        return (el.title.includes('vs') || el.title.includes('compare') || el.title.includes('comparision') || el.title.includes('alternative') || el.title.includes('alternatives') || el.title.includes('difference') || el.title.includes('compared to'))
      })
    }
    if (arg === 'Analyze Whole keyword report') {
      filterData = this.keyWordData;
    }
    this.dialog.closeAll();
    if (filterData.length > 0) {
      this.performSerpExtract(filterData);
      this.toastr.success(`Started Analyzing ${arg} Keywords. Use Filters to find them out in a Report.`)
    }
  }

  openDialog(data: string) {
    this.confirmationPopupData = data
    this.dialog.open(this.confirmationDialog, {
      width: '40%',
      panelClass:  !this.theme ? 'dark-modal-mat' : '' 
    });
  }
  cancelDialog() {
    this.dialog.closeAll();
  }
  jumpToPage() {
    this.page = this.jumpToPageCount;
    this.changePaginateData(this.activateLink);
  }
  collapseToggle(index: number) {
    this.paginateData[index].isShow = !this.paginateData[index].isShow;
    if (this.paginateData[index].isShow) {
      this.isClicked = true;
      this.clusteredData[index].volUparrow = false;
      this.clusteredData[index].volDownarrow = false;
      this.clusteredData[index].serpUpArrow = false;
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].weakSpotUpArrow = false;
      this.clusteredData[index].weakSpotDownArrow = false;
    }
    this.getClusterData(index)
  }

  getClusterDataFromDatabase(){
    this.loading = true
    this.editorService.getSavedClusterData({"lid": this.keyWordId}).subscribe((res:any)=>{
      try {
        this.loading = false
        if( typeof(res?.cluster_data?.cluster_data) != 'object' ){
          this.SERPSimilarity = res?.cluster_data?.SERPSimilarity
          let ary : any = JSON.parse(res?.cluster_data?.cluster_data)
          this.clusteredData = ary
          this.changePaginateData(this.activateLink);
          this.clusterLength = this.clusteredData.length
          // this.getClusterData(0)
        }
        if(this.clusteredData.length == 0){
          this.startClusturing()
        }
      } catch (error:any) {
        this.toastr.error(error.message)
      }
    })
  }

  startClusturing() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.clusteredData = [];
      if ((this.topResults && this.SERPSimilarity) !== '') {
        this.clustureService.calculateCluster(this.allPaginateData, this.SERPSimilarity, this.settingsData).then((res: any) => {
          res = res.sort((a: any, b: any) => {
            return b.cluster.length - a.cluster.length
          })
          // console.log(res)
          this.clusteredData = res;
          if(this.clusteredData.length != 0){
            this.saveClusterData(this.clusteredData)
          }
          this.changePaginateData(this.activateLink);
          this.clusterLength = this.clusteredData.length
        })
      }
    }, 3000);

  }

  saveClusterData(cluData : any){
    let newAry : any = []
    newAry = cluData.map((v:any)=>{
      let highObj = {title:v.HighestVolKey.title,vol:v.HighestVolKey.vol,cpc:v.HighestVolKey.cpc}
      let obj : any = {
        "HDA":v.HDA,
        "HighestVolKey":highObj,
        "cluster":v.cluster.map((e:any)=>{ return { "HDA":e.HDA, "LDA":e.LDA,"cpc":e.cpc,"data":e.data,"isChecked":e.isChecked,"isClustered":e.isClustered,"keywordPosition":e.keywordPosition,"running":e.running,"title":e.title,"vol":e.vol,"weakSpotCount":e.weakSpotCount }  }),
        "clusterVol":v.clusterVol,
        "clusterWeakSpotCount":v.clusterWeakSpotCount,
        "keywordPosition":v.keywordPosition,
        "paginateData": [],
        "title":v.title,
        "totalCount":v.totalCount,
        "weakSpotCount":v.weakSpotCount,
        "page":1
      }
      return obj
    })
    if(newAry.length != 0){
      let ary = JSON.stringify(newAry)
      this.editorService.saveClusterData({"lid": this.keyWordId,"SERPSimilarity":this.SERPSimilarity,clusterData:ary}).subscribe((res:any)=>{
        try {
          this.getClusterDataFromDatabase()
        } catch (error:any) {
          this.toastr.error(error.message)
        }
      })
    }
  }

  exportClusterExcel(){
    this.toastr.success("Excel download process is started");
    let clusterAry : any = []
    let ary = this.clusteredData.forEach((v:any)=>{
      if(v.cluster.length != 0){
        let i=0
        v.cluster.forEach((a:any)=>{
          let d = (a?.cpc?.value == "0" || a?.cpc?.value == null || a?.cpc?.value == undefined) ? "-" : a?.cpc?.currency + a?.cpc?.value;
          let Obj = {
            "main_keyword": i==0 ? v?.title : "",
            "totalKeyword": i==0 ? v?.totalCount : "",
            "weakKeyword":  i==0 ? v?.clusterWeakSpotCount : "",
            "totalClusterVol":i==0 ? v?.clusterVol : "",
            "title":a?.title,
            "vol":a?.vol ? a?.vol : '<10',
            "cpc":d,
          }
          clusterAry.push(Obj)
          i++
        })
      }
    })
    let obj : any = {
      "clusteredData" : clusterAry,
      "activateLink":this.activateLink,
      "keyWordName":this.keyWordName ? this.keyWordName : "excel"
    }
    this.clusterExcelLoader = true
    this.editorService.exportClusterExcel(obj).subscribe((res) => {
      try {
        this.clusterExcelLoader = false
        let dwldLink = document.createElement("a");
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_self");
        }
        
        dwldLink.setAttribute("href", `https://development.strell.io/TempExcel/strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);
        // dwldLink.setAttribute("href", `http://localhost:4000/TempExcel/${obj.keyWordName}.xlsx`);
        dwldLink.setAttribute("download", `strell_${obj.keyWordName.replace('/', '').replace('/', '')}_${new Date().toISOString().split('T')[0]}.xlsx`);

        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
      } catch (error: any) {
        this.toastr.error(error.message)
      }
    })
  }

  getClusterData(index: number) {
    let clusters: any = this.paginateData;
    this.paginateData[index].paginateData = clusters[index].cluster
      .slice((this.paginateData[index].page - 1) * 10, (this.paginateData[index].page - 1) * 10 + 10);
  }
  exportCluster() {
  }
  setActive(btnType: string) {
    if (btnType === "lessThan10") {
      this.daLessthan10 = !this.daLessthan10;
      if (this.daLessthan10) {
        this.filterData();
      } else {
        this.filterData();
      }
    } else {
      this.daLessthan20 = !this.daLessthan20;
      if (this.daLessthan20) {
        this.filterData();
      } else {
        this.filterData();
      }
    }
  }
  onSettingsAdd(eventData: any) {
    this.loading = true;
    this.editorService.saveDashboardSettings({
      "lid": this.keyWordId,
      "max_da": eventData.maxDa,
      "highlight_domain": eventData.customDomain,
      "my_site": eventData.mySites,
      "uid":this.uid,
      "type":"local"
    }).subscribe(res => {
      if (!!res && !res.error) {
        this.settingsData.type = "local"
        this.settingsData.theme = this.theme
        this.settingsData = eventData;
        this.getAllData();
        this.loading = false;
      }
    })
  }
  tabChanged(e:any){
    this.includeKeyword = ''
  }

  addExcludeKeywords(type:any){
    let keyword_ary : any = []
    this.exclude_any_keywords.push({ 'selected':false, title:this.excludeKeyword})
    keyword_ary.push(this.excludeKeyword)
    this.exclude_fix_keywords_backup.push(this.excludeKeyword)
    this.keyWordData = this.keyWordData.filter((v:any)=>{ 
        if(v?.title.toUpperCase().indexOf(this.excludeKeyword.toUpperCase()) !== -1){
          
        }else{
          return v
        }
      })
    this.loading = true
    if(this.excludeKeyword != ""){
      this.editorService.addExcludeKeywords({
        "lid": this.keyWordId,
        "type": "add",
        "keywords": keyword_ary,
      }).subscribe(res => {
        if (!!res) {
          this.loading = false
          this.filterData()
          this.toastr.info("keywords excludes successfully")
          keyword_ary = []
          this.excludeKeyword = ''
        }
      })
    }
  }
  removeExcludeKeyword(keyword:any){
    this.exclude_fix_keywords_backup = this.exclude_fix_keywords_backup.filter((v:any)=>v != keyword )
    this.exclude_any_keywords = this.exclude_any_keywords.filter((v:any)=>v.title != keyword)
    this.loading = true
    this.editorService.addExcludeKeywords({
      "lid": this.keyWordId,
      "type": "remove",
      "keywords": this.exclude_fix_keywords_backup,
    }).subscribe(res => {
      if (!!res) {
        this.loading = false
        this.getSuggestionAndQuestion('All');
        this.getSuggestionAndQuestion('Suggestion');
        this.getSuggestionAndQuestion('Question');
        this.changePaginateData(this.activateLink);
        this.filterData()
        this.toastr.info("excludes keywords remove successfully")
      }
    })
  }

  removeIncludeKeyword(keyword:any,type:any){
    let ary : any = []
    if(type == "Fix"){
      this.include_fix_keywords = this.include_fix_keywords.filter((v:any)=>{
        if(v.title != keyword){
          ary.push(v.title)
          return v
        }else{

        }
      })
      this.loading = true
      this.editorService.removeIncludeKeywords({
        "lid": this.keyWordId,
        "type": "Fix",
        "keywords": ary,
      }).subscribe(res => {
        if (!!res) {
          ary = []
          this.loading = false
          this.toastr.info("included keyword remove successfully")
        }
      })
    }else{
      this.include_any_keywords = this.include_any_keywords.filter((v:any)=>{
       if(v.title != keyword){
        ary.push(v.title)
        return v
       } 
      })
      this.loading = true
      this.editorService.removeIncludeKeywords({
        "lid": this.keyWordId,
        "type": "Any",
        "keywords": ary,
      }).subscribe(res => {
        if (!!res) {
          ary = []
          this.loading = false
          this.toastr.info("included keyword remove successfully")
        }
      })
    }
  }

  addIncludeKeyword(type:any){
    let keyword_ary : any= []
    if(type == "Fix"){
      keyword_ary.push(this.includeKeyword)
      this.include_fix_keywords.push({'selected':false,'title':this.includeKeyword})
    }else{
      keyword_ary.push(this.includeKeyword)
      this.include_any_keywords.push({'selected':false,'title':this.includeKeyword})
    }
    this.loading = true
    this.editorService.addIncludeKeywords({
      "lid": this.keyWordId,
      "type": type,
      "keywords": keyword_ary,
    }).subscribe(res => {
      if (!!res) {
        this.loading = false
        this.toastr.info("keywords Include successfully")
        keyword_ary = []
        this.includeKeyword = ''
      }
    })

  }

  fixIncludeFixFilter : any = []
  fixIncludeAnyFilter : any = []
  selectFixChip(keyword:any){
    this.include_fix_keywords.forEach((element:any) => {
      if (element.title == keyword.title) {
        element.selected = !element.selected;

        if (element.selected == true) {
          this.fixIncludeFixFilter.push(element.title);
        }
        else {
          this.fixIncludeFixFilter = this.fixIncludeFixFilter.filter((e:any) => {
            return e !== element.title;
          })
        }
      }
    });
    if (this.fixIncludeFixFilter.length > 0) {
      this.filterData();
    }else{
      this.filterData();
    }
  }
  selectAnyChip(keyword:any){
    this.include_any_keywords.forEach((element:any) => {
      if (element.title == keyword.title) {
        element.selected = !element.selected;

        if (element.selected == true) {
          this.fixIncludeAnyFilter.push(element.title);
        }
        else {
          this.fixIncludeAnyFilter = this.fixIncludeAnyFilter.filter((e:any) => {
            return e !== element.title;
          })
        }
      }
    });
    if (this.fixIncludeAnyFilter.length > 0) {
      this.filterData();
    }else{
      this.filterData();
    }
  }

  getGlobalSettingData(){
    this.loading = true
    this.editorService.getGlobalSettingData({
      "uid": this.uid,
    }).subscribe(res => {
      if (res && res.globalSetting.length != 0) {
        let data = res.globalSetting[0]
        // this.loading = false
        this.settingsData.maxDa = data.max_da === 0 ? 30 : data.max_da;
        this.settingsData.customDomain = JSON.parse(data.highlight_domain?.replace(/'/g, '"'))
        this.settingsData.mySites = JSON.parse(data.my_site?.replace(/'/g, '"'))
        this.settingsData.type = "global"
        this.settingsData.theme = this.theme
        this.editorService.sendLocalSettingData(this.settingsData)
      }
    })
  }

  addOneListName(){
    let data = {
      "type": "list",
      "uid": this.uid,
      "country": this.keyWordCountry,
      "language": this.keyWordLanguage,
      "keyword": this.listName
    }
    this.loading = true
    this.editorService.addLowFruitList(data).subscribe((res:any)=>{
      try {
        if(res){
          this.getListNames()
          this.modal.dismissAll();
          this.toastr.success("list add successfully")
          // this.keyWordData.forEach((v:any)=>{if(v.isChecked){v.isChecked = false}} )
          this.loading = false
        }
      } catch (error) {
        
      }
    })

  }

  getListNames(){
    this.editorService.getListName({lid:this.keyWordId,uid:this.uid}).subscribe((res:any)=>{
      try {
        if(res.listName.length != 0){
          let ary : any = []
          this.Lists = res.listName
          for(let i=0; i<res.listName.length; i++){
            let x = res.listName[i].customkeywordreport
            ary = ary.concat(x);
          }
          this.saveListKeywordAry = ary
          // this.saveListKeywordAry = res?.listName[0]?.saved_list_data_keyword?.keyword_data ? JSON.parse(res?.listName[0]?.saved_list_data_keyword?.keyword_data)  : []
        }
      } catch (error) {
        
      }
    })
  }
  saveListKeywordAry : any = []
  saveListData(lid:any,listName:any){
    let ary = []
    let withOutSerp : any = []
    let allCheckKeyword : any = []
    let keywordAry : any = []
    ary = this.keyWordData.filter((v:any)=>v.isChecked)
    ary.forEach(v=>{
      if(this.saveListKeywordAry.includes(v.title)){
        this.toastr.error(`${v.title} keyword is already added in list`)
        return
      }
      this.saveListKeywordAry.push(v.title)
      v.keywordPosition.length == 0 ? withOutSerp.push(v.title) : keywordAry.push(v.title)
      allCheckKeyword.push(v.title)
    })
    let paaAry : any = []
    let Related : any = []
    let searchResult : any = []
    let domainAry : any = []
    let volAry : any = []
    let oldObj : any = {}
    if(keywordAry.length == 0 && withOutSerp.length == 0 ){
      // this.toastr.error("Please Select any keyword to save in list")
      return
    }
    this.lckrKeyWordData.forEach((e: any) => {
      if (e.json_data?.data?.analysis) {
        for (const key in e.json_data.data.analysis) {
          if(keywordAry.includes(key) && !oldObj[key]  ){
            let Obj : any = {}
            Obj[key] = e.json_data?.data?.analysis[key] 
            Object.assign(oldObj, Obj);
            e.json_data?.data?.analysis[key].forEach((v:any)=>{ domainAry.push(v.domain) })
          }
        }
      }
      for( let i=0; i<keywordAry.length; i++ ){
        if (e.json_data?.data?.paa ) {
          let x :any = e.json_data?.data?.paa.filter((v:any)=> v[keywordAry[i]] &&  !paaAry.find((s:any)=> s[keywordAry[i]]) )
          x.length != 0 ? paaAry.push(x[0]) : ""
        }
        if (e.json_data?.data?.related) {
          let x :any = e.json_data?.data?.related.filter((v:any)=> v[keywordAry[i]] &&  !Related.find((s:any)=> s[keywordAry[i]]) )
          x.length != 0 ? Related.push(x[0]) : ""
        }
        if (e.json_data?.data?.search_result) {
          let x :any = e.json_data?.data?.search_result.filter((v:any)=> v[keywordAry[i]]  &&  !searchResult.find((s:any)=> s[keywordAry[i]]) )
          x.length != 0 ? searchResult.push(x[0]) : ""
        }
      }
    })
    volAry = this.voluman_data?.filter((v: any) => allCheckKeyword.includes(v?.keyword));

    let newDomainAry :any = []
    newDomainAry = [...new Set(domainAry)]
    let Obj = {
      lid:lid,
      uid:this.uid,
      customekeywordlist:allCheckKeyword,
      keywords:keywordAry,
      country: this.keyWordCountry,
      paa : paaAry,
      related : Related,
      search_result : searchResult,
      analysis : oldObj,
      domain : newDomainAry,
      volAry : volAry
    }
    this.loading = true
    this.editorService.addDataInList(Obj).subscribe((res:any)=>{
      try {
        if(res){
          keywordAry = []
          allCheckKeyword = []
          ary = []
          paaAry = []
          Related = []
          searchResult = []
          domainAry = []
          oldObj = {}
          this.toastr.success(  
          ` Keywords added to the list : <a href="https://${window.location.host}/lckr/dashboard/${lid}?type=list"  class="text-decoration-underline" > ${listName} </a> `,'',{enableHtml: true,timeOut: 20000,closeButton: true})
          this.keyWordData.forEach((v:any)=>{if(v.isChecked){v.isChecked = false}} )
          this.loading = false
        }
      } catch (error) {
        
      }
    })

  }

  logOut(){
    Gleap.clearIdentity();
    localStorage.clear()
    sessionStorage.clear()
    this.cookieServ.delete("uid", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("userName", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("email", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("plan", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("first_name", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("last_name", "/", window.location.hostname, true, "None");
    this.router.navigate(['login']);
  }

  deleteListKeyword(keyword:any){
    if(this.keyWordType == 'list'){
      const Obj = {
        lid:this.keyWordId,
        uid:this.uid,
        keyword:keyword
      }
      this.loading = true
      this.editorService.deleteListKeywords(Obj).subscribe((res:any)=>{
        if(res){
          this.toastr.success("List keyword deleted successfully.")
          this.getAllData()
        }
      })

    }
  }


}